/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AMLVerification = {
    No: 'No',
    Yes: 'Yes',
    Except: 'Except',
    NotAvailable: 'NotAvailable'
} as const;

export type AMLVerification = typeof AMLVerification[keyof typeof AMLVerification];


/**
 * 
 * @export
 * @enum {string}
 */

export const ActiveDirectoryAction = {
    Continue: 'Continue',
    ShowBlockPage: 'ShowBlockPage',
    ValidationError: 'ValidationError'
} as const;

export type ActiveDirectoryAction = typeof ActiveDirectoryAction[keyof typeof ActiveDirectoryAction];


/**
 * 
 * @export
 * @interface ActiveDirectoryUserIdRequest
 */
export interface ActiveDirectoryUserIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdRequest
     */
    'cipher': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdRequest
     */
    'tag': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdRequest
     */
    'nonce': string;
}
/**
 * 
 * @export
 * @interface ActiveDirectoryUserIdResponse
 */
export interface ActiveDirectoryUserIdResponse {
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdResponse
     */
    'objectId'?: string | null;
}


/**
 * 
 * @export
 * @interface AdditionalRegisterDataRequest
 */
export interface AdditionalRegisterDataRequest {
    /**
     * 
     * @type {string}
     * @memberof AdditionalRegisterDataRequest
     */
    'objectId': string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalRegisterDataRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalRegisterDataRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {AddressType}
     * @memberof Address
     */
    'type': AddressType;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'houseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'town'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'note'?: string | null;
}


/**
 * 
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * 
     * @type {AddressType}
     * @memberof AddressRequest
     */
    'type': AddressType;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'houseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'town': string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'note'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AddressType = {
    Delivery: 'Delivery',
    Permanent: 'Permanent',
    Financial: 'Financial',
    Unknown: 'Unknown'
} as const;

export type AddressType = typeof AddressType[keyof typeof AddressType];


/**
 * 
 * @export
 * @interface AesGcmEncryptResponse
 */
export interface AesGcmEncryptResponse {
    /**
     * 
     * @type {string}
     * @memberof AesGcmEncryptResponse
     */
    'cipher': string;
    /**
     * 
     * @type {string}
     * @memberof AesGcmEncryptResponse
     */
    'tag': string;
    /**
     * 
     * @type {string}
     * @memberof AesGcmEncryptResponse
     */
    'cryptographicNonce': string;
}
/**
 * 
 * @export
 * @interface Allocation
 */
export interface Allocation {
    /**
     * 
     * @type {FundCode}
     * @memberof Allocation
     */
    'fundCode': FundCode;
    /**
     * 
     * @type {string}
     * @memberof Allocation
     */
    'fundName': string;
    /**
     * 
     * @type {number}
     * @memberof Allocation
     */
    'allocation': number;
}


/**
 * 
 * @export
 * @interface AllowedChangesItem
 */
export interface AllowedChangesItem {
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'contractId': string;
    /**
     * 
     * @type {ProductType}
     * @memberof AllowedChangesItem
     */
    'productType': ProductType;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'hasAnyFailedChanges': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'isElectronicContactsChangeInProgress': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'isContactAddressChangeInProgress': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChengeInflationProgram': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeEmployerOrClientContribution': boolean;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'contributionDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeContactAddress': boolean;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'contactAddressDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'beneficiariesDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeElectronicContacts': boolean;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'electronicContactsDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeTaxOptimum': boolean;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'taxOptimumDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeAmlIdentification': boolean;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'amlIdentificationDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeIsEmployerContributing': boolean;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'isEmployerContributingDescription'?: string | null;
    /**
     * 
     * @type {Array<PensionPendingChange>}
     * @memberof AllowedChangesItem
     */
    'pendingChanges'?: Array<PensionPendingChange> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeInvestmentStrategy'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'canChangeBeneficiaries'?: boolean | null;
    /**
     * 
     * @type {Array<ChangesDisabledReason>}
     * @memberof AllowedChangesItem
     */
    'reasons'?: Array<ChangesDisabledReason> | null;
    /**
     * 
     * @type {string}
     * @memberof AllowedChangesItem
     */
    'inflationDescription': string;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'isClientIdentified'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'isBankIdIdentificationRequired'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'isAmlFulfilled'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllowedChangesItem
     */
    'isRiderWithoutNullableValuePUStart'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AreConsentsNeededResponse
 */
export interface AreConsentsNeededResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AreConsentsNeededResponse
     */
    'isNeeded': boolean;
}
/**
 * 
 * @export
 * @interface AssignMasterKeyRequest
 */
export interface AssignMasterKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignMasterKeyRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignMasterKeyRequest
     */
    'master-key': string;
    /**
     * 
     * @type {string}
     * @memberof AssignMasterKeyRequest
     */
    'employee-id': string;
}
/**
 * 
 * @export
 * @interface AssignPidRequest
 */
export interface AssignPidRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignPidRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignPidRequest
     */
    'pid': string;
    /**
     * 
     * @type {string}
     * @memberof AssignPidRequest
     */
    'employeeId': string;
}
/**
 * 
 * @export
 * @interface Assignee
 */
export interface Assignee {
    /**
     * 
     * @type {number}
     * @memberof Assignee
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface Attention
 */
export interface Attention {
    /**
     * 
     * @type {AttentionType}
     * @memberof Attention
     */
    'type': AttentionType;
    /**
     * 
     * @type {number}
     * @memberof Attention
     */
    'amount'?: number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AttentionType = {
    Debt: 'Debt',
    TaxBonus: 'TaxBonus',
    Error: 'Error',
    Warning: 'Warning'
} as const;

export type AttentionType = typeof AttentionType[keyof typeof AttentionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const AuthenticationSourceType = {
    Unknown: 'Unknown',
    LocalAccountAuthentication: 'LocalAccountAuthentication',
    SocialIdpAuthentication: 'SocialIdpAuthentication'
} as const;

export type AuthenticationSourceType = typeof AuthenticationSourceType[keyof typeof AuthenticationSourceType];


/**
 * 
 * @export
 * @interface AuthorizeRequest
 */
export interface AuthorizeRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeRequest
     */
    'cipher': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeRequest
     */
    'tag': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeRequest
     */
    'nonce': string;
}
/**
 * 
 * @export
 * @interface AuthorizeResponse
 */
export interface AuthorizeResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof AuthorizeResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof AuthorizeResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof AuthorizeResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AuthorizeResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'objectId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'PID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'MPK'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'BANKER_ID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'BIRTHNUMBER'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'PHONE'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeResponse
     */
    'EMAIL'?: string | null;
}


/**
 * 
 * @export
 * @interface BankIdCreateLoginPayloadResponse
 */
export interface BankIdCreateLoginPayloadResponse {
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    'cipher': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    'tag': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    'nonce': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdCreateLoginPayloadResponse
     */
    'expiresAt': string;
}
/**
 * 
 * @export
 * @interface BankIdLoginPayloadRequest
 */
export interface BankIdLoginPayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginPayloadRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginPayloadRequest
     */
    'redirect_uri': string;
}
/**
 * 
 * @export
 * @interface BankIdRegisterPayloadRequest
 */
export interface BankIdRegisterPayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof BankIdRegisterPayloadRequest
     */
    'sub': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdRegisterPayloadRequest
     */
    'guid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdRegisterPayloadRequest
     */
    'birthNumber': string;
}
/**
 * 
 * @export
 * @interface BankIdValidateLoginRequest
 */
export interface BankIdValidateLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof BankIdValidateLoginRequest
     */
    'cipher': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdValidateLoginRequest
     */
    'tag': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdValidateLoginRequest
     */
    'nonce': string;
}
/**
 * 
 * @export
 * @interface Beneficiary
 */
export interface Beneficiary {
    /**
     * 
     * @type {string}
     * @memberof Beneficiary
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Beneficiary
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Beneficiary
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Beneficiary
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {BeneficiaryRelationship}
     * @memberof Beneficiary
     */
    'relationship': BeneficiaryRelationship;
    /**
     * 
     * @type {number}
     * @memberof Beneficiary
     */
    'ratio': number;
    /**
     * 
     * @type {Address}
     * @memberof Beneficiary
     */
    'address'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof Beneficiary
     */
    'isBank': boolean;
}


/**
 * 
 * @export
 * @interface BeneficiaryParty
 */
export interface BeneficiaryParty {
    /**
     * 
     * @type {Participant}
     * @memberof BeneficiaryParty
     */
    'beneficiary': Participant;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryParty
     */
    'relationship'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryParty
     */
    'beneficiaryShare': number;
    /**
     * 
     * @type {boolean}
     * @memberof BeneficiaryParty
     */
    'isBank': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BeneficiaryRelationship = {
    Other: 'Other',
    HusbandOrWife: 'HusbandOrWife',
    Fiance: 'Fiance',
    RegisteredPartner: 'RegisteredPartner',
    Child: 'Child',
    BrotherOrSister: 'BrotherOrSister',
    Parent: 'Parent',
    Bank: 'Bank'
} as const;

export type BeneficiaryRelationship = typeof BeneficiaryRelationship[keyof typeof BeneficiaryRelationship];


/**
 * 
 * @export
 * @interface BeneficiaryRequest
 */
export interface BeneficiaryRequest {
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryRequest
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {BeneficiaryRelationship}
     * @memberof BeneficiaryRequest
     */
    'relationship'?: BeneficiaryRelationship;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryRequest
     */
    'ratio': number;
    /**
     * 
     * @type {AddressRequest}
     * @memberof BeneficiaryRequest
     */
    'address'?: AddressRequest;
}


/**
 * 
 * @export
 * @interface CallCenterAccountDeletionResult
 */
export interface CallCenterAccountDeletionResult {
    /**
     * 
     * @type {string}
     * @memberof CallCenterAccountDeletionResult
     */
    'operationId': string;
    /**
     * 
     * @type {CallCenterAccountDeletionResultState}
     * @memberof CallCenterAccountDeletionResult
     */
    'state': CallCenterAccountDeletionResultState;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CallCenterAccountDeletionResultState = {
    NotFound: 'NotFound',
    InProgress: 'InProgress',
    Committed: 'Committed',
    Failed: 'Failed',
    Conflict: 'Conflict'
} as const;

export type CallCenterAccountDeletionResultState = typeof CallCenterAccountDeletionResultState[keyof typeof CallCenterAccountDeletionResultState];


/**
 * 
 * @export
 * @interface ChangeAdditionalData
 */
export interface ChangeAdditionalData {
    /**
     * 
     * @type {FileDownloadInfo}
     * @memberof ChangeAdditionalData
     */
    'dpsPrecontractualInfo': FileDownloadInfo;
    /**
     * 
     * @type {DocumentDownloadResponse}
     * @memberof ChangeAdditionalData
     */
    'zzjDocumentInfo'?: DocumentDownloadResponse;
}
/**
 * 
 * @export
 * @interface ChangeContactAddressesRequest
 */
export interface ChangeContactAddressesRequest {
    /**
     * 
     * @type {Address}
     * @memberof ChangeContactAddressesRequest
     */
    'address': Address;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeContactAddressesRequest
     */
    'isGlobalChange': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChangeContactAddressesRequest
     */
    'contractNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ChangeFundsRequest
 */
export interface ChangeFundsRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeFundsRequest
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeFundsRequest
     */
    'authenticationPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeFundsRequest
     */
    'smsCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeFundsRequest
     */
    'dpsPrecontractualInfoName': string;
    /**
     * 
     * @type {ZZJInformationRequest}
     * @memberof ChangeFundsRequest
     */
    'zzjInformation': ZZJInformationRequest;
    /**
     * 
     * @type {Array<CustomAllocation>}
     * @memberof ChangeFundsRequest
     */
    'recommendedStrategy': Array<CustomAllocation>;
    /**
     * Questionnaire version flag: \"1\" = old questionnaire, \"2\" = new questionnaire.  Optional. When null or missing the handler defaults to \"1\".
     * @type {string}
     * @memberof ChangeFundsRequest
     */
    'questionnaireVersion'?: string | null;
}
/**
 * 
 * @export
 * @interface ChangeMpkRequest
 */
export interface ChangeMpkRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeMpkRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeMpkRequest
     */
    'newMpk': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeMpkRequest
     */
    'employeeId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChangeRequestType = {
    All: 'All',
    Contract: 'Contract',
    Requirements: 'Requirements',
    Funds: 'Funds'
} as const;

export type ChangeRequestType = typeof ChangeRequestType[keyof typeof ChangeRequestType];


/**
 * 
 * @export
 * @interface ChangeResources
 */
export interface ChangeResources {
    /**
     * 
     * @type {boolean}
     * @memberof ChangeResources
     */
    'acceptRecommendedStrategy': boolean;
    /**
     * 
     * @type {Array<CustomAllocation>}
     * @memberof ChangeResources
     */
    'customAllocation'?: Array<CustomAllocation> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChangeScope = {
    Contract: 'Contract',
    Client: 'Client'
} as const;

export type ChangeScope = typeof ChangeScope[keyof typeof ChangeScope];


/**
 * 
 * @export
 * @enum {string}
 */

export const ChangeType = {
    Unknown: 'Unknown',
    AskForContact: 'AskForContact',
    ChangeElectronicContacts: 'ChangeElectronicContacts',
    ChangeContactAddress: 'ChangeContactAddress',
    ChangeNewDpsResources: 'ChangeNewDPSResources',
    ChangeExistingDpsResources: 'ChangeExistingDPSResources',
    ChangeNewAndExistingDpsResources: 'ChangeNewAndExistingDPSResources',
    SetContactDetails: 'SetContactDetails',
    SetDeliveryAddress: 'SetDeliveryAddress',
    SetPermanentAddress: 'SetPermanentAddress',
    SetMarketingConsent: 'SetMarketingConsent',
    SetDsFunds: 'SetDsFunds',
    SetFunds: 'SetFunds',
    SetClientIdentEmail: 'SetClientIdentEmail',
    SetClientIdentMsisdn: 'SetClientIdentMsisdn',
    SetContractTransStmtDelivery: 'SetContractTransStmtDelivery',
    SetContractTaxStmtDelivery: 'SetContractTaxStmtDelivery',
    SetContractMonthlyPaymentOwner: 'SetContractMonthlyPaymentOwner',
    SetContractPaymentFrequency: 'SetContractPaymentFrequency',
    SetContractIsTaxOptimum: 'SetContractIsTaxOptimum',
    SetContractTaxDeductable: 'SetContractTaxDeductable',
    SetContractVoluntaryPayIn: 'SetContractVoluntaryPayIn',
    SetContractEmployer: 'SetContractEmployer',
    SetTaxStmtDelivery: 'SetTaxStmtDelivery',
    SetPaymentType: 'SetPaymentType',
    SetInflation: 'SetInflation',
    SetBeneficiaries: 'SetBeneficiaries',
    SetEmailNotification: 'SetEmailNotification',
    UnsetClientIdent: 'UnsetClientIdent',
    SetAmlIdentification: 'SetAmlIdentification',
    InflationClause: 'InflationClause',
    ChangeAuthorizationContacts: 'ChangeAuthorizationContacts'
} as const;

export type ChangeType = typeof ChangeType[keyof typeof ChangeType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ChangesDisabledReason = {
    None: 'None',
    BeneficiaryChangeInProgress: 'BeneficiaryChangeInProgress',
    BeneficiaryIsABank: 'BeneficiaryIsABank',
    HasNoBeneficiaries: 'HasNoBeneficiaries',
    FutureEmployerOrClientContributionChange: 'FutureEmployerOrClientContributionChange'
} as const;

export type ChangesDisabledReason = typeof ChangesDisabledReason[keyof typeof ChangesDisabledReason];


/**
 * 
 * @export
 * @enum {string}
 */

export const ClientAuthorizationPropertyType = {
    Phone: 'Phone',
    Email: 'Email'
} as const;

export type ClientAuthorizationPropertyType = typeof ClientAuthorizationPropertyType[keyof typeof ClientAuthorizationPropertyType];


/**
 * 
 * @export
 * @interface CmsWarningsResponse
 */
export interface CmsWarningsResponse {
    /**
     * 
     * @type {string}
     * @memberof CmsWarningsResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CmsWarningsResponse
     */
    'warning'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CmsWarningsResponse
     */
    'info'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CmsWarningsResponse
     */
    'success'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConsentType = {
    Marketing: 'Marketing',
    ElectronicCommunication: 'ElectronicCommunication',
    ElectronicContracting: 'ElectronicContracting'
} as const;

export type ConsentType = typeof ConsentType[keyof typeof ConsentType];


/**
 * 
 * @export
 * @interface ContactAddress
 */
export interface ContactAddress {
    /**
     * 
     * @type {string}
     * @memberof ContactAddress
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ContactAddress
     */
    'title': string;
    /**
     * 
     * @type {ProductType}
     * @memberof ContactAddress
     */
    'type': ProductType;
    /**
     * 
     * @type {InsuredPersonInfo}
     * @memberof ContactAddress
     */
    'firstInsuredPerson'?: InsuredPersonInfo;
    /**
     * 
     * @type {Address}
     * @memberof ContactAddress
     */
    'address': Address;
    /**
     * 
     * @type {boolean}
     * @memberof ContactAddress
     */
    'isContactAddressChangeInProgress': boolean;
}


/**
 * 
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'phone1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'phone2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactInfo
     */
    'isChangeInProgress': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContactType = {
    Agent: 'Agent',
    Broker: 'Broker',
    Default: 'Default'
} as const;

export type ContactType = typeof ContactType[keyof typeof ContactType];


/**
 * 
 * @export
 * @interface Contacts
 */
export interface Contacts {
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'phoneAdditional'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    'dataBoxId'?: string | null;
}
/**
 * 
 * @export
 * @interface ContractParametersDPS
 */
export interface ContractParametersDPS {
    /**
     * 
     * @type {string}
     * @memberof ContractParametersDPS
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersDPS
     */
    'signatureDate': string;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersDPS
     */
    'registrationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersDPS
     */
    'effectiveDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersDPS
     */
    'retirementDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersDPS
     */
    'isTaxOptimum': boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractParametersDPS
     */
    'monthlyContributionClient': number;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersDPS
     */
    'lastMonthlyContributionChangeDate'?: string | null;
    /**
     * 
     * @type {PaymentFrequency}
     * @memberof ContractParametersDPS
     */
    'contributionFrequency': PaymentFrequency;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersDPS
     */
    'doesEmployerContribute': boolean;
    /**
     * 
     * @type {DeliveryType}
     * @memberof ContractParametersDPS
     */
    'taxStatementDelivery': DeliveryType;
    /**
     * 
     * @type {DeliveryType}
     * @memberof ContractParametersDPS
     */
    'transactionsStatementDelivery': DeliveryType;
}


/**
 * 
 * @export
 * @interface ContractParametersLife
 */
export interface ContractParametersLife {
    /**
     * 
     * @type {string}
     * @memberof ContractParametersLife
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersLife
     */
    'signatureDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersLife
     */
    'discountGroup'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractParametersLife
     */
    'discountPercent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersLife
     */
    'doesEmployerContribute': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersLife
     */
    'hasTaxBenefit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersLife
     */
    'allowTaxBenefitChanges': boolean;
    /**
     * 
     * @type {DeliveryType}
     * @memberof ContractParametersLife
     */
    'taxStatementDelivery': DeliveryType;
    /**
     * 
     * @type {InflationProgramLife}
     * @memberof ContractParametersLife
     */
    'inflationProgram'?: InflationProgramLife;
    /**
     * 
     * @type {GroupCategoryCd}
     * @memberof ContractParametersLife
     */
    'groupCategory'?: GroupCategoryCd;
}


/**
 * 
 * @export
 * @interface ContractParametersPP
 */
export interface ContractParametersPP {
    /**
     * 
     * @type {string}
     * @memberof ContractParametersPP
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersPP
     */
    'signatureDate': string;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersPP
     */
    'registrationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersPP
     */
    'effectiveDate': string;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersPP
     */
    'retirementDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersPP
     */
    'isTaxOptimum': boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractParametersPP
     */
    'monthlyContributionClient': number;
    /**
     * 
     * @type {PaymentFrequency}
     * @memberof ContractParametersPP
     */
    'contributionFrequency': PaymentFrequency;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersPP
     */
    'doesEmployerContribute': boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractParametersPP
     */
    'monthlyContributionOthers': number;
    /**
     * 
     * @type {DeliveryType}
     * @memberof ContractParametersPP
     */
    'transactionsStatementDelivery': DeliveryType;
    /**
     * 
     * @type {DeliveryType}
     * @memberof ContractParametersPP
     */
    'taxStatementDelivery': DeliveryType;
    /**
     * 
     * @type {number}
     * @memberof ContractParametersPP
     */
    'pensionPlan'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractParametersPP
     */
    'isEarlyRetirement': boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractParametersPP
     */
    'earlyRetirementDate'?: string | null;
}


/**
 * 
 * @export
 * @interface ContractPaymentInfo
 */
export interface ContractPaymentInfo {
    /**
     * 
     * @type {Array<LifePaymentInfoGroup>}
     * @memberof ContractPaymentInfo
     */
    'list': Array<LifePaymentInfoGroup>;
    /**
     * 
     * @type {number}
     * @memberof ContractPaymentInfo
     */
    'clientCredit': number;
    /**
     * 
     * @type {number}
     * @memberof ContractPaymentInfo
     */
    'employerCredit': number;
    /**
     * 
     * @type {string}
     * @memberof ContractPaymentInfo
     */
    'paymentMethod': string;
}
/**
 * 
 * @export
 * @interface ContractPerson
 */
export interface ContractPerson {
    /**
     * 
     * @type {Person}
     * @memberof ContractPerson
     */
    'person': Person;
    /**
     * 
     * @type {ContractPersonRole}
     * @memberof ContractPerson
     */
    'role': ContractPersonRole;
    /**
     * 
     * @type {Contacts}
     * @memberof ContractPerson
     */
    'contacts'?: Contacts;
    /**
     * 
     * @type {NdpAddress}
     * @memberof ContractPerson
     */
    'contactAddress'?: NdpAddress;
    /**
     * 
     * @type {NdpAddress}
     * @memberof ContractPerson
     */
    'permanentAddress'?: NdpAddress;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ContractPersonRole = {
    Owner: 'Owner',
    Insured: 'Insured',
    OwnerAndInsured: 'OwnerAndInsured'
} as const;

export type ContractPersonRole = typeof ContractPersonRole[keyof typeof ContractPersonRole];


/**
 * 
 * @export
 * @interface Contributions
 */
export interface Contributions {
    /**
     * 
     * @type {number}
     * @memberof Contributions
     */
    'owner': number;
    /**
     * 
     * @type {number}
     * @memberof Contributions
     */
    'employer': number;
    /**
     * 
     * @type {number}
     * @memberof Contributions
     */
    'others': number;
    /**
     * 
     * @type {number}
     * @memberof Contributions
     */
    'state': number;
    /**
     * 
     * @type {number}
     * @memberof Contributions
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface Coverage
 */
export interface Coverage {
    /**
     * 
     * @type {number}
     * @memberof Coverage
     */
    'id': number;
    /**
     * 
     * @type {CoverageKindEnum}
     * @memberof Coverage
     */
    'coverageKind': CoverageKindEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Coverage
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof Coverage
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Coverage
     */
    'isMain': boolean;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'dateStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'dateEnd'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Coverage
     */
    'sumAssured': number;
    /**
     * 
     * @type {number}
     * @memberof Coverage
     */
    'sumAtRiskAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Coverage
     */
    'currentSumAssured': number;
    /**
     * 
     * @type {number}
     * @memberof Coverage
     */
    'premium': number;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'exclusion'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CoverageKindEnum = {
    Coverage: 'Coverage',
    ChildCoverage: 'ChildCoverage',
    SummaryCoverage: 'SummaryCoverage',
    PremiumFactor: 'PremiumFactor'
} as const;

export type CoverageKindEnum = typeof CoverageKindEnum[keyof typeof CoverageKindEnum];


/**
 * 
 * @export
 * @interface CreateLoginPayloadRequest
 */
export interface CreateLoginPayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadRequest
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadRequest
     */
    'bankerId'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateLoginPayloadResponse
 */
export interface CreateLoginPayloadResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadResponse
     */
    'targetUrl': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadResponse
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoginPayloadResponse
     */
    'expiresAt': string;
}
/**
 * 
 * @export
 * @interface CustomAllocation
 */
export interface CustomAllocation {
    /**
     * 
     * @type {FundCode}
     * @memberof CustomAllocation
     */
    'fundCode': FundCode;
    /**
     * 
     * @type {number}
     * @memberof CustomAllocation
     */
    'allocation': number;
}


/**
 * 
 * @export
 * @interface DailyValue
 */
export interface DailyValue {
    /**
     * 
     * @type {string}
     * @memberof DailyValue
     */
    'day': string;
    /**
     * 
     * @type {number}
     * @memberof DailyValue
     */
    'value': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeliveryType = {
    Post: 'Post',
    Electronically: 'Electronically'
} as const;

export type DeliveryType = typeof DeliveryType[keyof typeof DeliveryType];


/**
 * 
 * @export
 * @interface DevelopmentDataConfig
 */
export interface DevelopmentDataConfig {
    /**
     * 
     * @type {boolean}
     * @memberof DevelopmentDataConfig
     */
    'includeFufi': boolean;
}
/**
 * 
 * @export
 * @interface DocumentDownloadResponse
 */
export interface DocumentDownloadResponse {
    /**
     * 
     * @type {number}
     * @memberof DocumentDownloadResponse
     */
    'nodeId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDownloadResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDownloadResponse
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDownloadResponse
     */
    'mimeType': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDownloadResponse
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDownloadResponse
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDownloadResponse
     */
    'downloadPath': string;
    /**
     * 
     * @type {ProductType}
     * @memberof DocumentDownloadResponse
     */
    'productType': ProductType;
}


/**
 * 
 * @export
 * @interface Employer
 */
export interface Employer {
    /**
     * 
     * @type {string}
     * @memberof Employer
     */
    'ico'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Employer
     */
    'name'?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof Employer
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface EnableUserAccountRequest
 */
export interface EnableUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof EnableUserAccountRequest
     */
    'objectId': string;
    /**
     * 
     * @type {string}
     * @memberof EnableUserAccountRequest
     */
    'verifiedPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnableUserAccountRequest
     */
    'verifiedEmail'?: string | null;
}
/**
 * 
 * @export
 * @interface EncryptUserDetailInfoRequest
 */
export interface EncryptUserDetailInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'birthdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'targetUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptUserDetailInfoRequest
     */
    'targetObjectId'?: string | null;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'data'?: string | null;
}
/**
 * 
 * @export
 * @interface Evaluations
 */
export interface Evaluations {
    /**
     * 
     * @type {number}
     * @memberof Evaluations
     */
    'owner': number;
    /**
     * 
     * @type {number}
     * @memberof Evaluations
     */
    'state': number;
    /**
     * 
     * @type {number}
     * @memberof Evaluations
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FileDownloadInfo
 */
export interface FileDownloadInfo {
    /**
     * 
     * @type {string}
     * @memberof FileDownloadInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FileDownloadInfo
     */
    'mimeType': string;
    /**
     * 
     * @type {number}
     * @memberof FileDownloadInfo
     */
    'fileSize': number;
    /**
     * 
     * @type {string}
     * @memberof FileDownloadInfo
     */
    'downloadPath': string;
}
/**
 * 
 * @export
 * @interface FinalizeRegisterDataRequest
 */
export interface FinalizeRegisterDataRequest {
    /**
     * 
     * @type {string}
     * @memberof FinalizeRegisterDataRequest
     */
    'objectId': string;
}
/**
 * 
 * @export
 * @interface FufiAllocationRateItem
 */
export interface FufiAllocationRateItem {
    /**
     * 
     * @type {string}
     * @memberof FufiAllocationRateItem
     */
    'fundCode': string;
    /**
     * 
     * @type {number}
     * @memberof FufiAllocationRateItem
     */
    'allocation': number;
    /**
     * 
     * @type {string}
     * @memberof FufiAllocationRateItem
     */
    'fundName'?: string | null;
}
/**
 * 
 * @export
 * @interface FufiContractSavingsDto
 */
export interface FufiContractSavingsDto {
    /**
     * 
     * @type {string}
     * @memberof FufiContractSavingsDto
     */
    'proposalNumber': string;
    /**
     * 
     * @type {string}
     * @memberof FufiContractSavingsDto
     */
    'contractNumber': string;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'inPoolCashValueDeemed': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'inPoolCashValueReal': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'accPoolCashValue': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'ae28CashValue': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'cashValue': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'surrenderValue': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'pendingDeduction': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'maxPartialSurrender': number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    'uninvestedAmount': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FufiContributionType = {
    Employer: 'Employer',
    Employee: 'Employee',
    Unknown: 'Unknown'
} as const;

export type FufiContributionType = typeof FufiContributionType[keyof typeof FufiContributionType];


/**
 * 
 * @export
 * @interface FufiFinancialInfoMoneyIn
 */
export interface FufiFinancialInfoMoneyIn {
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'id': string;
    /**
     * 
     * @type {FufiPaymentType}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'type': FufiPaymentType;
    /**
     * 
     * @type {FufiContributionType}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'contractContributionType': FufiContributionType;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'amount': number;
    /**
     * 
     * @type {FufiPaymentStatus}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'status': FufiPaymentStatus;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'applied': number;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoMoneyIn
     */
    'refunded'?: number | null;
}


/**
 * 
 * @export
 * @interface FufiFinancialInfoPremium
 */
export interface FufiFinancialInfoPremium {
    /**
     * 
     * @type {FufiFinancialInfoPremiumFrequency}
     * @memberof FufiFinancialInfoPremium
     */
    'frequency': FufiFinancialInfoPremiumFrequency;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoPremium
     */
    'periodFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoPremium
     */
    'periodTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoPremium
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoPremium
     */
    'dueDate': string;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoPremium
     */
    'paymentDate'?: string | null;
    /**
     * 
     * @type {FufiFinancialInfoPremiumStatus}
     * @memberof FufiFinancialInfoPremium
     */
    'paymentStatus': FufiFinancialInfoPremiumStatus;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoPremium
     */
    'balance': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FufiFinancialInfoPremiumFrequency = {
    HalfYearly: 'HalfYearly',
    Monthly: 'Monthly',
    OneTime: 'OneTime',
    Quarterly: 'Quarterly',
    Yearly: 'Yearly',
    Unknown: 'Unknown'
} as const;

export type FufiFinancialInfoPremiumFrequency = typeof FufiFinancialInfoPremiumFrequency[keyof typeof FufiFinancialInfoPremiumFrequency];


/**
 * 
 * @export
 * @enum {string}
 */

export const FufiFinancialInfoPremiumStatus = {
    Unpaid: 'Unpaid',
    PartiallyPaid: 'PartiallyPaid',
    FullyPaid: 'FullyPaid',
    Unknown: 'Unknown'
} as const;

export type FufiFinancialInfoPremiumStatus = typeof FufiFinancialInfoPremiumStatus[keyof typeof FufiFinancialInfoPremiumStatus];


/**
 * 
 * @export
 * @interface FufiFinancialInfoQuery
 */
export interface FufiFinancialInfoQuery {
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    'moneyInsPageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    'moneyInsPage'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoQuery
     */
    'moneyInsFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoQuery
     */
    'moneyInsTo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    'premiumsPageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    'premiumsPage'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoQuery
     */
    'premiumsFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoQuery
     */
    'premiumsTo'?: string | null;
    /**
     * 
     * @type {Array<FufiContributionType>}
     * @memberof FufiFinancialInfoQuery
     */
    'moneyInsPayerTypes'?: Array<FufiContributionType> | null;
    /**
     * 
     * @type {Array<FufiPaymentType>}
     * @memberof FufiFinancialInfoQuery
     */
    'moneyInsPaymentTypes'?: Array<FufiPaymentType> | null;
}
/**
 * 
 * @export
 * @interface FufiFinancialInfoResponse
 */
export interface FufiFinancialInfoResponse {
    /**
     * 
     * @type {Array<FufiFinancialInfoMoneyIn>}
     * @memberof FufiFinancialInfoResponse
     */
    'moneyIns'?: Array<FufiFinancialInfoMoneyIn> | null;
    /**
     * 
     * @type {Array<FufiFinancialInfoPremium>}
     * @memberof FufiFinancialInfoResponse
     */
    'premiums'?: Array<FufiFinancialInfoPremium> | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    'moneyInsCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    'premiumsCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoResponse
     */
    'effectDate': string;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoResponse
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoResponse
     */
    'proposalNumber': string;
    /**
     * 
     * @type {string}
     * @memberof FufiFinancialInfoResponse
     */
    'paidToDate': string;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    'debt': number;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    'totalWritten': number;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoResponse
     */
    'totalPaid': number;
}
/**
 * 
 * @export
 * @interface FufiInvestmentItem
 */
export interface FufiInvestmentItem {
    /**
     * 
     * @type {string}
     * @memberof FufiInvestmentItem
     */
    'fundCode': string;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    'allocation': number;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    'fundValue': number;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    'nbUnits'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    'unitVal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FufiInvestmentItem
     */
    'fundName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FufiPaymentStatus = {
    Unknown: 'Unknown',
    Pending: 'Pending',
    Paid: 'Paid',
    Payable: 'Payable'
} as const;

export type FufiPaymentStatus = typeof FufiPaymentStatus[keyof typeof FufiPaymentStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const FufiPaymentType = {
    Unknown: 'Unknown',
    Normal: 'Normal',
    Unsolicited: 'Unsolicited',
    Unsolved: 'Unsolved'
} as const;

export type FufiPaymentType = typeof FufiPaymentType[keyof typeof FufiPaymentType];


/**
 * 
 * @export
 * @interface Fund
 */
export interface Fund {
    /**
     * 
     * @type {string}
     * @memberof Fund
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Fund
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Fund
     */
    'puAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Fund
     */
    'puValue': number;
    /**
     * Used by pension life funds   Amount of initial investment units
     * @type {number}
     * @memberof Fund
     */
    'valuePUStart': number;
    /**
     * Used by pension funds
     * @type {number}
     * @memberof Fund
     */
    'balanceRatio': number;
    /**
     * Used by pension and life funds
     * @type {number}
     * @memberof Fund
     */
    'depositRatio': number;
    /**
     * Used by life funds
     * @type {number}
     * @memberof Fund
     */
    'depositTopUpRatio'?: number | null;
    /**
     * 
     * @type {FundCode}
     * @memberof Fund
     */
    'code'?: FundCode;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FundCode = {
    Con: 'CON',
    Bal: 'BAL',
    Grow: 'GROW'
} as const;

export type FundCode = typeof FundCode[keyof typeof FundCode];


/**
 * 
 * @export
 * @enum {string}
 */

export const GenderEnum = {
    Male: 'Male',
    Female: 'Female',
    Unknown: 'Unknown'
} as const;

export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];


/**
 * 
 * @export
 * @interface GetAdUsersResponse
 */
export interface GetAdUsersResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'creationType': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'pid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'createdDateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdUsersResponse
     */
    'lastSignInDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAdUsersResponse
     */
    'loginAttempts'?: number | null;
}
/**
 * 
 * @export
 * @interface GetAllowedChangesResponse
 */
export interface GetAllowedChangesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetAllowedChangesResponse
     */
    'isGlobalContactAddressChangeEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllowedChangesResponse
     */
    'hasAnyFailedChange': boolean;
    /**
     * 
     * @type {Array<AllowedChangesItem>}
     * @memberof GetAllowedChangesResponse
     */
    'contracts': Array<AllowedChangesItem>;
}
/**
 * 
 * @export
 * @interface GetAuthorizationDataResponse
 */
export interface GetAuthorizationDataResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationDataResponse
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationDataResponse
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface GetAuthorizationEmailAddressRequest
 */
export interface GetAuthorizationEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationEmailAddressRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface GetAuthorizationEmailAddressResponse
 */
export interface GetAuthorizationEmailAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationEmailAddressResponse
     */
    'emailAddress'?: string | null;
}


/**
 * 
 * @export
 * @interface GetAuthorizationPhoneNumberRequest
 */
export interface GetAuthorizationPhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationPhoneNumberRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface GetAuthorizationPhoneNumberResponse
 */
export interface GetAuthorizationPhoneNumberResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizationPhoneNumberResponse
     */
    'phoneNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface GetChangesResponse
 */
export interface GetChangesResponse {
    /**
     * 
     * @type {ChangeScope}
     * @memberof GetChangesResponse
     */
    'changeScope': ChangeScope;
    /**
     * 
     * @type {ProductType}
     * @memberof GetChangesResponse
     */
    'productType': ProductType;
    /**
     * 
     * @type {string}
     * @memberof GetChangesResponse
     */
    'productId': string;
    /**
     * 
     * @type {ChangeType}
     * @memberof GetChangesResponse
     */
    'changeType': ChangeType;
    /**
     * 
     * @type {RequirementStatus}
     * @memberof GetChangesResponse
     */
    'status': RequirementStatus;
    /**
     * 
     * @type {string}
     * @memberof GetChangesResponse
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetChangesResponse
     */
    'resolvedDate'?: string | null;
    /**
     * 
     * @type {ChangeAdditionalData}
     * @memberof GetChangesResponse
     */
    'additionalData'?: ChangeAdditionalData;
}


/**
 * 
 * @export
 * @interface GetConsentResponse
 */
export interface GetConsentResponse {
    /**
     * 
     * @type {ConsentType}
     * @memberof GetConsentResponse
     */
    'type': ConsentType;
    /**
     * 
     * @type {boolean}
     * @memberof GetConsentResponse
     */
    'consent': boolean;
}


/**
 * 
 * @export
 * @interface GetContactAddressesResponse
 */
export interface GetContactAddressesResponse {
    /**
     * 
     * @type {Array<ContactAddress>}
     * @memberof GetContactAddressesResponse
     */
    'contactAddresses': Array<ContactAddress>;
    /**
     * 
     * @type {boolean}
     * @memberof GetContactAddressesResponse
     */
    'isGlobalContactAddressChangeEnabled': boolean;
}
/**
 * 
 * @export
 * @interface GetContactsResponse
 */
export interface GetContactsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetContactsResponse
     */
    'name'?: string | null;
    /**
     * Null for Type = ContactType.Default
     * @type {string}
     * @memberof GetContactsResponse
     */
    'productName'?: string | null;
    /**
     * 
     * @type {ContactType}
     * @memberof GetContactsResponse
     */
    'type': ContactType;
    /**
     * 
     * @type {string}
     * @memberof GetContactsResponse
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetContactsResponse
     */
    'email'?: string | null;
}


/**
 * 
 * @export
 * @interface GetContractsResponse
 */
export interface GetContractsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetContractsResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetContractsResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetContractsResponse
     */
    'proposalNumber'?: string | null;
    /**
     * 
     * @type {ProductType}
     * @memberof GetContractsResponse
     */
    'type': ProductType;
    /**
     * 
     * @type {string}
     * @memberof GetContractsResponse
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof GetContractsResponse
     */
    'amount': number;
    /**
     * 
     * @type {PaymentFrequency}
     * @memberof GetContractsResponse
     */
    'paymentFrequency'?: PaymentFrequency;
    /**
     * 
     * @type {PensionPhaseStatus}
     * @memberof GetContractsResponse
     */
    'pensionPhaseStatus'?: PensionPhaseStatus;
    /**
     * 
     * @type {Array<Attention>}
     * @memberof GetContractsResponse
     */
    'attentions': Array<Attention>;
    /**
     * LifeTransaction for Life contracts or PensionTransaction for Pension contracts
     * @type {boolean}
     * @memberof GetContractsResponse
     */
    'isChildrenContract': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetContractsResponse
     */
    'childName'?: string | null;
}


/**
 * 
 * @export
 * @interface GetDPSDetailResponse
 */
export interface GetDPSDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof GetDPSDetailResponse
     */
    'savedAmount': number;
    /**
     * 
     * @type {Array<Fund>}
     * @memberof GetDPSDetailResponse
     */
    'funds': Array<Fund>;
    /**
     * 
     * @type {boolean}
     * @memberof GetDPSDetailResponse
     */
    'isFundsChangeInProgress': boolean;
    /**
     * 
     * @type {PensionPaymentInfo}
     * @memberof GetDPSDetailResponse
     */
    'clientPaymentInfo': PensionPaymentInfo;
    /**
     * 
     * @type {PensionPaymentInfo}
     * @memberof GetDPSDetailResponse
     */
    'employerPaymentInfo': PensionPaymentInfo;
    /**
     * 
     * @type {SharedClient}
     * @memberof GetDPSDetailResponse
     */
    'clientInfo': SharedClient;
    /**
     * 
     * @type {ContactInfo}
     * @memberof GetDPSDetailResponse
     */
    'contact': ContactInfo;
    /**
     * 
     * @type {Address}
     * @memberof GetDPSDetailResponse
     */
    'permanentAddress': Address;
    /**
     * 
     * @type {Address}
     * @memberof GetDPSDetailResponse
     */
    'contactAddress': Address;
    /**
     * 
     * @type {boolean}
     * @memberof GetDPSDetailResponse
     */
    'isContactAddressChangeInProgress': boolean;
    /**
     * 
     * @type {ContractParametersDPS}
     * @memberof GetDPSDetailResponse
     */
    'contract': ContractParametersDPS;
    /**
     * 
     * @type {Array<PensionBeneficiary>}
     * @memberof GetDPSDetailResponse
     */
    'beneficiaries': Array<PensionBeneficiary>;
    /**
     * 
     * @type {PensionContractStatus}
     * @memberof GetDPSDetailResponse
     */
    'status': PensionContractStatus;
    /**
     * 
     * @type {Employer}
     * @memberof GetDPSDetailResponse
     */
    'employer'?: Employer;
    /**
     * 
     * @type {boolean}
     * @memberof GetDPSDetailResponse
     */
    'isChildrenContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDPSDetailResponse
     */
    'isClientIdentified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDPSDetailResponse
     */
    'isAmlFulfilled': boolean;
    /**
     * 
     * @type {StarPensionClientTypeEnum}
     * @memberof GetDPSDetailResponse
     */
    'clientType': StarPensionClientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDPSDetailResponse
     */
    'questionnaireSubmitDate'?: string | null;
}


/**
 * 
 * @export
 * @interface GetFufiInvestmentsResponse
 */
export interface GetFufiInvestmentsResponse {
    /**
     * 
     * @type {Array<FufiInvestmentItem>}
     * @memberof GetFufiInvestmentsResponse
     */
    'investments': Array<FufiInvestmentItem>;
    /**
     * 
     * @type {Array<FufiAllocationRateItem>}
     * @memberof GetFufiInvestmentsResponse
     */
    'allocationRatio': Array<FufiAllocationRateItem>;
    /**
     * 
     * @type {FufiContractSavingsDto}
     * @memberof GetFufiInvestmentsResponse
     */
    'contractSavings': FufiContractSavingsDto;
}
/**
 * 
 * @export
 * @interface GetFundsPerformanceResponse
 */
export interface GetFundsPerformanceResponse {
    /**
     * 
     * @type {string}
     * @memberof GetFundsPerformanceResponse
     */
    'name': string;
    /**
     * 
     * @type {Array<DailyValue>}
     * @memberof GetFundsPerformanceResponse
     */
    'values': Array<DailyValue>;
}
/**
 * 
 * @export
 * @interface GetLifeDetailResponse
 */
export interface GetLifeDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailResponse
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailResponse
     */
    'balanceTotal': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailResponse
     */
    'totalDebit': number;
    /**
     * 
     * @type {Array<Fund>}
     * @memberof GetLifeDetailResponse
     */
    'funds': Array<Fund>;
    /**
     * 
     * @type {ContractPaymentInfo}
     * @memberof GetLifeDetailResponse
     */
    'paymentInfo': ContractPaymentInfo;
    /**
     * 
     * @type {SharedClient}
     * @memberof GetLifeDetailResponse
     */
    'clientInfo': SharedClient;
    /**
     * 
     * @type {Array<InsuredPerson>}
     * @memberof GetLifeDetailResponse
     */
    'insuredPersons': Array<InsuredPerson>;
    /**
     * 
     * @type {ContractParametersLife}
     * @memberof GetLifeDetailResponse
     */
    'contract': ContractParametersLife;
    /**
     * 
     * @type {Array<PriceItem>}
     * @memberof GetLifeDetailResponse
     */
    'priceBreakdown': Array<PriceItem>;
    /**
     * 
     * @type {LifeContractStatus}
     * @memberof GetLifeDetailResponse
     */
    'status': LifeContractStatus;
    /**
     * 
     * @type {Employer}
     * @memberof GetLifeDetailResponse
     */
    'employer'?: Employer;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailResponse
     */
    'investmentStrategy'?: string | null;
    /**
     * Not null for SMART contract type
     * @type {number}
     * @memberof GetLifeDetailResponse
     */
    'payoutVariant'?: number | null;
    /**
     * Approximate customer surrender value, the amount a person would  receive if they withdraw money from their own life insurance
     * @type {number}
     * @memberof GetLifeDetailResponse
     */
    'surrValue': number;
}


/**
 * 
 * @export
 * @interface GetLifeDetailV2Response
 */
export interface GetLifeDetailV2Response {
    /**
     * 
     * @type {Participant}
     * @memberof GetLifeDetailV2Response
     */
    'owner'?: Participant;
    /**
     * 
     * @type {Array<NdpInsuredPerson>}
     * @memberof GetLifeDetailV2Response
     */
    'insuredPersons': Array<NdpInsuredPerson>;
    /**
     * 
     * @type {Array<ContractPerson>}
     * @memberof GetLifeDetailV2Response
     */
    'personsOnContract': Array<ContractPerson>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetLifeDetailV2Response
     */
    'beneficiaries': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetLifeDetailV2Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'proposalNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'contractNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'dateSignature': string;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'dateIssue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'dateStart': string;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'dateEnd': string;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'technicalStartDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLifeDetailV2Response
     */
    'hasTaxAdvantage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetLifeDetailV2Response
     */
    'doesEmployerContribute': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'premiumClient': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'premiumEmployer': number;
    /**
     * 
     * @type {PaymentFrequency}
     * @memberof GetLifeDetailV2Response
     */
    'paymentFrequency': PaymentFrequency;
    /**
     * 
     * @type {PaymentInstructions}
     * @memberof GetLifeDetailV2Response
     */
    'paymentDetails': PaymentInstructions;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'commonStatusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'commonStatusDescription'?: string | null;
    /**
     * 
     * @type {ProductClasType}
     * @memberof GetLifeDetailV2Response
     */
    'productClass'?: ProductClasType;
    /**
     * 
     * @type {ProductNameType}
     * @memberof GetLifeDetailV2Response
     */
    'productName'?: ProductNameType;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'productDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'productCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeDetailV2Response
     */
    'sourceSystem'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'premiumTotal': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'debtClient': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'debtEmployer': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'overpaymentClient': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'overpaymentEmployer': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'surrenderValue': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'sumPremiumClient': number;
    /**
     * 
     * @type {number}
     * @memberof GetLifeDetailV2Response
     */
    'sumPremiumEmployer': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetLifeDetailV2Response
     */
    'taxDeductionLifeFlag'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLifeDetailV2Response
     */
    'taxDeductionLtcFlag'?: boolean | null;
}


/**
 * 
 * @export
 * @interface GetLifeTransactionsResponse
 */
export interface GetLifeTransactionsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLifeTransactionsResponse
     */
    'amount': number;
    /**
     * Payment date
     * @type {string}
     * @memberof GetLifeTransactionsResponse
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof GetLifeTransactionsResponse
     */
    'typeFull': string;
    /**
     * 
     * @type {LifeTransactionEnum}
     * @memberof GetLifeTransactionsResponse
     */
    'type': LifeTransactionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetLifeTransactionsResponse
     */
    'title': string;
    /**
     * 
     * @type {LifeTransactionStatus}
     * @memberof GetLifeTransactionsResponse
     */
    'status': LifeTransactionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetLifeTransactionsResponse
     */
    'isPaid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetLifeTransactionsResponse
     */
    'periodFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeTransactionsResponse
     */
    'periodTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLifeTransactionsResponse
     */
    'maturityDate': string;
}


/**
 * 
 * @export
 * @interface GetNdpClientContractsRequest
 */
export interface GetNdpClientContractsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsRequest
     */
    'mpk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsRequest
     */
    'contractNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsRequest
     */
    'birthNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GetNdpClientContractsResponse
 */
export interface GetNdpClientContractsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'mpk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'contractNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'proposalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'productType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsResponse
     */
    'sourceSystem'?: string | null;
}
/**
 * 
 * @export
 * @interface GetODSClientsResponse
 */
export interface GetODSClientsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'pid': string;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'birthNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'birthDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'emails'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'phones'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetODSClientsResponse
     */
    'contractNumbers'?: string | null;
}
/**
 * 
 * @export
 * @interface GetPPDetailResponse
 */
export interface GetPPDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPPDetailResponse
     */
    'savedAmount': number;
    /**
     * 
     * @type {Contributions}
     * @memberof GetPPDetailResponse
     */
    'contributionsBreakdown': Contributions;
    /**
     * 
     * @type {Evaluations}
     * @memberof GetPPDetailResponse
     */
    'evaluationsBreakdown': Evaluations;
    /**
     * 
     * @type {PensionPaymentInfo}
     * @memberof GetPPDetailResponse
     */
    'clientPaymentInfo': PensionPaymentInfo;
    /**
     * 
     * @type {PensionPaymentInfo}
     * @memberof GetPPDetailResponse
     */
    'employerPaymentInfo': PensionPaymentInfo;
    /**
     * 
     * @type {SharedClient}
     * @memberof GetPPDetailResponse
     */
    'clientInfo': SharedClient;
    /**
     * 
     * @type {ContactInfo}
     * @memberof GetPPDetailResponse
     */
    'contact': ContactInfo;
    /**
     * 
     * @type {Address}
     * @memberof GetPPDetailResponse
     */
    'permanentAddress': Address;
    /**
     * 
     * @type {Address}
     * @memberof GetPPDetailResponse
     */
    'contactAddress'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof GetPPDetailResponse
     */
    'isContactAddressChangeInProgress': boolean;
    /**
     * 
     * @type {ContractParametersPP}
     * @memberof GetPPDetailResponse
     */
    'contract': ContractParametersPP;
    /**
     * 
     * @type {Array<PensionBeneficiary>}
     * @memberof GetPPDetailResponse
     */
    'beneficiaries': Array<PensionBeneficiary>;
    /**
     * 
     * @type {Employer}
     * @memberof GetPPDetailResponse
     */
    'employer'?: Employer;
    /**
     * 
     * @type {Array<PensionPendingChange>}
     * @memberof GetPPDetailResponse
     */
    'pendingChanges': Array<PensionPendingChange>;
    /**
     * 
     * @type {boolean}
     * @memberof GetPPDetailResponse
     */
    'isClientIdentified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPPDetailResponse
     */
    'isAmlFulfilled': boolean;
    /**
     * 
     * @type {StarPensionClientTypeEnum}
     * @memberof GetPPDetailResponse
     */
    'clientType': StarPensionClientTypeEnum;
}


/**
 * 
 * @export
 * @interface GetPensionTransactionsResponse
 */
export interface GetPensionTransactionsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPensionTransactionsResponse
     */
    'amount': number;
    /**
     * Date of creation
     * @type {string}
     * @memberof GetPensionTransactionsResponse
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof GetPensionTransactionsResponse
     */
    'typeFull': string;
    /**
     * 
     * @type {PensionTransactionEnum}
     * @memberof GetPensionTransactionsResponse
     */
    'type': PensionTransactionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPensionTransactionsResponse
     */
    'title': string;
}


/**
 * 
 * @export
 * @interface GetProfileResponse
 */
export interface GetProfileResponse {
    /**
     * 
     * @type {SharedClient}
     * @memberof GetProfileResponse
     */
    'client': SharedClient;
    /**
     * 
     * @type {Array<Address>}
     * @memberof GetProfileResponse
     */
    'permanentAddresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProfileResponse
     */
    'mobile'?: string | null;
}
/**
 * 
 * @export
 * @interface GetProfileV2Response
 */
export interface GetProfileV2Response {
    /**
     * 
     * @type {SharedClient}
     * @memberof GetProfileV2Response
     */
    'client': SharedClient;
    /**
     * 
     * @type {string}
     * @memberof GetProfileV2Response
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProfileV2Response
     */
    'mobile'?: string | null;
}
/**
 * 
 * @export
 * @interface GetRegisteredUsersResponse
 */
export interface GetRegisteredUsersResponse {
    /**
     * 
     * @type {Array<RegisteredUser>}
     * @memberof GetRegisteredUsersResponse
     */
    'items': Array<RegisteredUser>;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegisteredUsersResponse
     */
    'nextPage': boolean;
}
/**
 * 
 * @export
 * @interface GetSignInHistoryResponse
 */
export interface GetSignInHistoryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSignInHistoryResponse
     */
    'events': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetSignInHistoryResponse
     */
    'totalCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSignInHistoryResponse
     */
    'nextPage': boolean;
}
/**
 * 
 * @export
 * @interface GetZZJPreviewRequest
 */
export interface GetZZJPreviewRequest {
    /**
     * 
     * @type {ZZJInformationRequest}
     * @memberof GetZZJPreviewRequest
     */
    'zzjInformation': ZZJInformationRequest;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GroupCategoryCd = {
    CzechRailways: 'CzechRailways',
    Other: 'Other'
} as const;

export type GroupCategoryCd = typeof GroupCategoryCd[keyof typeof GroupCategoryCd];


/**
 * 
 * @export
 * @enum {string}
 */

export const IdentificationStatusNR = {
    NeverIdentified: 'NeverIdentified',
    InProgress: 'InProgress',
    Identified: 'Identified',
    OutdatedDueToError: 'OutdatedDueToError',
    Failed: 'Failed',
    Blocked: 'Blocked'
} as const;

export type IdentificationStatusNR = typeof IdentificationStatusNR[keyof typeof IdentificationStatusNR];


/**
 * 
 * @export
 * @interface IdentityDocument
 */
export interface IdentityDocument {
    /**
     * 
     * @type {number}
     * @memberof IdentityDocument
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof IdentityDocument
     */
    'identityNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityDocument
     */
    'identityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityDocument
     */
    'identityExpiryDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityDocument
     */
    'identityAuthority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityDocument
     */
    'sourceSystem'?: string | null;
}
/**
 * 
 * @export
 * @interface ImpersonateUserRequest
 */
export interface ImpersonateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ImpersonateUserRequest
     */
    'employeeId': string;
    /**
     * 
     * @type {string}
     * @memberof ImpersonateUserRequest
     */
    'targetUserMpk': string;
    /**
     * 
     * @type {string}
     * @memberof ImpersonateUserRequest
     */
    'employeeLogin': string;
}
/**
 * 
 * @export
 * @interface InflationProgramLife
 */
export interface InflationProgramLife {
    /**
     * 
     * @type {string}
     * @memberof InflationProgramLife
     */
    'anniversaryDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'canUserEditSettings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'inflationIncreaseOfferFlag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'inflationIncreaseFlag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'independentIncreaseOfferFlag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'independentIncreaseFlag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'indexOptionOfferFlag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'indexOptionFlag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    'isProcessingInflation': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InsuranceTypeEnum = {
    Life: 'Life',
    Child: 'Child'
} as const;

export type InsuranceTypeEnum = typeof InsuranceTypeEnum[keyof typeof InsuranceTypeEnum];


/**
 * 
 * @export
 * @interface InsuredPerson
 */
export interface InsuredPerson {
    /**
     * 
     * @type {string}
     * @memberof InsuredPerson
     */
    'degreeBefore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InsuredPerson
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InsuredPerson
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InsuredPerson
     */
    'degreeAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InsuredPerson
     */
    'birthNumber'?: string | null;
    /**
     * Null for Children
     * @type {string}
     * @memberof InsuredPerson
     */
    'dateOfBirth'?: string | null;
    /**
     * Null for Children
     * @type {string}
     * @memberof InsuredPerson
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof InsuredPerson
     */
    'permanentAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof InsuredPerson
     */
    'contactAddress'?: Address;
    /**
     * Valid only for PolicyHolder
     * @type {boolean}
     * @memberof InsuredPerson
     */
    'isContactAddressChangeInProgress': boolean;
    /**
     * 
     * @type {ContactInfo}
     * @memberof InsuredPerson
     */
    'contact'?: ContactInfo;
    /**
     * 
     * @type {Array<Rider>}
     * @memberof InsuredPerson
     */
    'riders': Array<Rider>;
    /**
     * Empty for Children
     * @type {Array<Beneficiary>}
     * @memberof InsuredPerson
     */
    'beneficiaries': Array<Beneficiary>;
    /**
     * 
     * @type {InsuredPersonRole}
     * @memberof InsuredPerson
     */
    'role': InsuredPersonRole;
}


/**
 * 
 * @export
 * @interface InsuredPersonInfo
 */
export interface InsuredPersonInfo {
    /**
     * 
     * @type {string}
     * @memberof InsuredPersonInfo
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InsuredPersonInfo
     */
    'birthday'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InsuredPersonRole = {
    PolicyHolder: 'PolicyHolder',
    PolicyHolderAndFirst: 'PolicyHolderAndFirst',
    PolicyHolderAndSecond: 'PolicyHolderAndSecond',
    First: 'First',
    Second: 'Second',
    Children: 'Children'
} as const;

export type InsuredPersonRole = typeof InsuredPersonRole[keyof typeof InsuredPersonRole];


/**
 * 
 * @export
 * @interface InvestorProfileResult
 */
export interface InvestorProfileResult {
    /**
     * 
     * @type {Profile}
     * @memberof InvestorProfileResult
     */
    'investmentProfile': Profile;
    /**
     * 
     * @type {Strategy}
     * @memberof InvestorProfileResult
     */
    'investmentStrategy': Strategy;
}
/**
 * 
 * @export
 * @interface IsContractPresentResponse
 */
export interface IsContractPresentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IsContractPresentResponse
     */
    'isPresent': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const KindEnum = {
    Person: 'Person',
    Organization: 'Organization'
} as const;

export type KindEnum = typeof KindEnum[keyof typeof KindEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const LifeContractStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    InsuredEvent: 'InsuredEvent',
    PaidUp: 'PaidUp',
    RegisteredDeath: 'RegisteredDeath'
} as const;

export type LifeContractStatus = typeof LifeContractStatus[keyof typeof LifeContractStatus];


/**
 * 
 * @export
 * @interface LifePaymentInfo
 */
export interface LifePaymentInfo {
    /**
     * 
     * @type {string}
     * @memberof LifePaymentInfo
     */
    'accountNumber': string;
    /**
     * 
     * @type {number}
     * @memberof LifePaymentInfo
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof LifePaymentInfo
     */
    'constantSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof LifePaymentInfo
     */
    'variableSymbol': string;
    /**
     * 
     * @type {PaymentFrequency}
     * @memberof LifePaymentInfo
     */
    'frequency'?: PaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof LifePaymentInfo
     */
    'iban': string;
    /**
     * Null for extraordinary payments
     * @type {string}
     * @memberof LifePaymentInfo
     */
    'nextPaymentDate'?: string | null;
}


/**
 * 
 * @export
 * @interface LifePaymentInfoGroup
 */
export interface LifePaymentInfoGroup {
    /**
     * 
     * @type {PaymentInfoType}
     * @memberof LifePaymentInfoGroup
     */
    'type': PaymentInfoType;
    /**
     * 
     * @type {LifePaymentInfo}
     * @memberof LifePaymentInfoGroup
     */
    'client': LifePaymentInfo;
    /**
     * 
     * @type {LifePaymentInfo}
     * @memberof LifePaymentInfoGroup
     */
    'employer': LifePaymentInfo;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const LifeTransactionEnum = {
    Other: 'Other',
    LifeInsurer: 'LifeInsurer',
    LifeEmployer: 'LifeEmployer',
    LifePayIn: 'LifePayIn',
    LifePayOut: 'LifePayOut'
} as const;

export type LifeTransactionEnum = typeof LifeTransactionEnum[keyof typeof LifeTransactionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const LifeTransactionStatus = {
    Paid: 'Paid',
    Pending: 'Pending',
    Returned: 'Returned',
    Cancelled: 'Cancelled',
    Unknown: 'Unknown'
} as const;

export type LifeTransactionStatus = typeof LifeTransactionStatus[keyof typeof LifeTransactionStatus];


/**
 * 
 * @export
 * @interface LocalAccountRegistrationRequest
 */
export interface LocalAccountRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    'birth_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    'birth_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    'last_name'?: string | null;
}
/**
 * 
 * @export
 * @interface NdpAddress
 */
export interface NdpAddress {
    /**
     * 
     * @type {number}
     * @memberof NdpAddress
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'houseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'countryA3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'countryA2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'zipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'addressTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'addressTypeDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpAddress
     */
    'sourceSystem'?: string | null;
}
/**
 * 
 * @export
 * @interface NdpInsuredPerson
 */
export interface NdpInsuredPerson {
    /**
     * 
     * @type {Person}
     * @memberof NdpInsuredPerson
     */
    'person': Person;
    /**
     * 
     * @type {InsuranceTypeEnum}
     * @memberof NdpInsuredPerson
     */
    'insuranceType': InsuranceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NdpInsuredPerson
     */
    'insuranceStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpInsuredPerson
     */
    'commonStatusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NdpInsuredPerson
     */
    'commonStatusDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NdpInsuredPerson
     */
    'order': number;
    /**
     * 
     * @type {Array<BeneficiaryParty>}
     * @memberof NdpInsuredPerson
     */
    'beneficiaries': Array<BeneficiaryParty>;
    /**
     * 
     * @type {Array<Coverage>}
     * @memberof NdpInsuredPerson
     */
    'coverages': Array<Coverage>;
    /**
     * 
     * @type {Array<Assignee>}
     * @memberof NdpInsuredPerson
     */
    'assignees': Array<Assignee>;
    /**
     * 
     * @type {Contacts}
     * @memberof NdpInsuredPerson
     */
    'contacts'?: Contacts;
    /**
     * 
     * @type {NdpAddress}
     * @memberof NdpInsuredPerson
     */
    'contactAddress'?: NdpAddress;
    /**
     * 
     * @type {NdpAddress}
     * @memberof NdpInsuredPerson
     */
    'permanentAddress'?: NdpAddress;
    /**
     * 
     * @type {string}
     * @memberof NdpInsuredPerson
     */
    'fufiBeneficiaryString'?: string | null;
}


/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {number}
     * @memberof Organization
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'foundationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organizationKindCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'taxIdentificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'vatIdentificationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'sourceSystem'?: string | null;
}
/**
 * 
 * @export
 * @interface Participant
 */
export interface Participant {
    /**
     * 
     * @type {number}
     * @memberof Participant
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Participant
     */
    'masterId': number;
    /**
     * 
     * @type {KindEnum}
     * @memberof Participant
     */
    'kind': KindEnum;
    /**
     * 
     * @type {TypeEnum}
     * @memberof Participant
     */
    'type': TypeEnum;
    /**
     * 
     * @type {Person}
     * @memberof Participant
     */
    'person'?: Person;
    /**
     * 
     * @type {Organization}
     * @memberof Participant
     */
    'organization'?: Organization;
    /**
     * 
     * @type {NdpAddress}
     * @memberof Participant
     */
    'permanentAddress'?: NdpAddress;
    /**
     * 
     * @type {NdpAddress}
     * @memberof Participant
     */
    'contactAddress'?: NdpAddress;
    /**
     * 
     * @type {Contacts}
     * @memberof Participant
     */
    'contacts': Contacts;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    'sourceSystem'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentFrequency = {
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    HalfYearly: 'HalfYearly',
    Yearly: 'Yearly',
    Other: 'Other',
    OneTime: 'OneTime'
} as const;

export type PaymentFrequency = typeof PaymentFrequency[keyof typeof PaymentFrequency];


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentInfoType = {
    Regular: 'Regular',
    Extraordinary: 'Extraordinary',
    ExtraordinaryFunds: 'ExtraordinaryFunds',
    ExtraordinaryFundsWithGuaranteedPayoff: 'ExtraordinaryFundsWithGuaranteedPayoff',
    ExtraordinaryGuarenteedFunds: 'ExtraordinaryGuarenteedFunds'
} as const;

export type PaymentInfoType = typeof PaymentInfoType[keyof typeof PaymentInfoType];


/**
 * 
 * @export
 * @interface PaymentInstructions
 */
export interface PaymentInstructions {
    /**
     * 
     * @type {number}
     * @memberof PaymentInstructions
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentInstructions
     */
    'bankAccount': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentInstructions
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentInstructions
     */
    'variableSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentInstructions
     */
    'specificSymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInstructions
     */
    'nextDueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInstructions
     */
    'paidToDate'?: string | null;
}
/**
 * 
 * @export
 * @interface PendingChangeDetail
 */
export interface PendingChangeDetail {
    /**
     * Will only be included when ChangeType is ChangeContribution
     * @type {number}
     * @memberof PendingChangeDetail
     */
    'newClientContribution'?: number | null;
    /**
     * Will only be included when ChangeType is ChangeContribution
     * @type {boolean}
     * @memberof PendingChangeDetail
     */
    'willEmployerContribute'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PendingChangeType = {
    Other: 'Other',
    ChangeContribution: 'ChangeContribution'
} as const;

export type PendingChangeType = typeof PendingChangeType[keyof typeof PendingChangeType];


/**
 * 
 * @export
 * @interface PensionBeneficiary
 */
export interface PensionBeneficiary {
    /**
     * 
     * @type {number}
     * @memberof PensionBeneficiary
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiary
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiary
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiary
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiary
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {PensionBeneficiaryRelationship}
     * @memberof PensionBeneficiary
     */
    'relationship'?: PensionBeneficiaryRelationship;
    /**
     * 
     * @type {number}
     * @memberof PensionBeneficiary
     */
    'ratio'?: number | null;
    /**
     * 
     * @type {PensionBeneficiaryAddress}
     * @memberof PensionBeneficiary
     */
    'address'?: PensionBeneficiaryAddress;
    /**
     * 
     * @type {IdentificationStatusNR}
     * @memberof PensionBeneficiary
     */
    'identificationStatusNR'?: IdentificationStatusNR;
}


/**
 * 
 * @export
 * @interface PensionBeneficiaryAddress
 */
export interface PensionBeneficiaryAddress {
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiaryAddress
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiaryAddress
     */
    'houseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiaryAddress
     */
    'town'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiaryAddress
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiaryAddress
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PensionBeneficiaryAddress
     */
    'countryName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PensionBeneficiaryRelationship = {
    Other: 'Other',
    HusbandOrWife: 'HusbandOrWife',
    Fiance: 'Fiance',
    RegisteredPartner: 'RegisteredPartner',
    Child: 'Child',
    BrotherOrSister: 'BrotherOrSister',
    Parent: 'Parent'
} as const;

export type PensionBeneficiaryRelationship = typeof PensionBeneficiaryRelationship[keyof typeof PensionBeneficiaryRelationship];


/**
 * 
 * @export
 * @enum {string}
 */

export const PensionContractStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    Pending: 'Pending',
    Proposal: 'Proposal'
} as const;

export type PensionContractStatus = typeof PensionContractStatus[keyof typeof PensionContractStatus];


/**
 * 
 * @export
 * @interface PensionPaymentInfo
 */
export interface PensionPaymentInfo {
    /**
     * 
     * @type {string}
     * @memberof PensionPaymentInfo
     */
    'accountNumber': string;
    /**
     * Null for employer contribution
     * @type {number}
     * @memberof PensionPaymentInfo
     */
    'monthlyContribution'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PensionPaymentInfo
     */
    'constantSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof PensionPaymentInfo
     */
    'variableSymbol': string;
    /**
     * 
     * @type {PaymentFrequency}
     * @memberof PensionPaymentInfo
     */
    'frequency': PaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof PensionPaymentInfo
     */
    'iban': string;
}


/**
 * 
 * @export
 * @interface PensionPendingChange
 */
export interface PensionPendingChange {
    /**
     * 
     * @type {string}
     * @memberof PensionPendingChange
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof PensionPendingChange
     */
    'validFromDate': string;
    /**
     * 
     * @type {PendingChangeType}
     * @memberof PensionPendingChange
     */
    'changeType': PendingChangeType;
    /**
     * 
     * @type {PendingChangeDetail}
     * @memberof PensionPendingChange
     */
    'detail': PendingChangeDetail;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PensionPhaseStatus = {
    Saving: 'Saving',
    Payout: 'Payout'
} as const;

export type PensionPhaseStatus = typeof PensionPhaseStatus[keyof typeof PensionPhaseStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const PensionTransactionEnum = {
    Other: 'Other',
    ContribEmployer: 'ContribEmployer',
    ContribClient: 'ContribClient',
    ContribState: 'ContribState'
} as const;

export type PensionTransactionEnum = typeof PensionTransactionEnum[keyof typeof PensionTransactionEnum];


/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'titlePrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'titleSuffix'?: string | null;
    /**
     * 
     * @type {GenderEnum}
     * @memberof Person
     */
    'gender': GenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'citizenshipA2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'citizenshipA3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'countryOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'countryOfBirthA2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'countryOfBirthA3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'birthPlace'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    'isAdult': boolean;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'riskCddLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'dateLastCddCheck'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'dateNextCddCheck'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    'isPEP': boolean;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    'amlRiskCategory': number;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'amlRiskCategoryReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'sourceSystem'?: string | null;
    /**
     * 
     * @type {Array<IdentityDocument>}
     * @memberof Person
     */
    'identityDocuments': Array<IdentityDocument>;
}


/**
 * 
 * @export
 * @interface PickedAnswerRequest
 */
export interface PickedAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof PickedAnswerRequest
     */
    'questionId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickedAnswerRequest
     */
    'choices': Array<string>;
}
/**
 * 
 * @export
 * @interface PossibleAnswer
 */
export interface PossibleAnswer {
    /**
     * 
     * @type {string}
     * @memberof PossibleAnswer
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PossibleAnswer
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof PossibleAnswer
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface PostLoginResponse
 */
export interface PostLoginResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'isRegistrationCompleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'isPendingMpkResolution': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'startConsentGathering': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'startElectronicContactsConfirmation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'hasRecentElectronicContactsChange': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'isPhoneVerified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginResponse
     */
    'isEmailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostLoginResponse
     */
    'userEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostLoginResponse
     */
    'userPhone'?: string | null;
}
/**
 * 
 * @export
 * @interface PriceItem
 */
export interface PriceItem {
    /**
     * 
     * @type {string}
     * @memberof PriceItem
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PriceItem
     */
    'amount': number;
    /**
     * 
     * @type {PriceItemType}
     * @memberof PriceItem
     */
    'type': PriceItemType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PriceItemType = {
    MainRider: 'MainRider',
    Rider: 'Rider',
    Discount: 'Discount',
    Surcharge: 'Surcharge'
} as const;

export type PriceItemType = typeof PriceItemType[keyof typeof PriceItemType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductClasType = {
    Rsk: 'RSK',
    Ul: 'UL',
    RskUl: 'RSK_UL',
    PseudoRsk: 'PSEUDO_RSK'
} as const;

export type ProductClasType = typeof ProductClasType[keyof typeof ProductClasType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductNameType = {
    NnOrangeRisk: 'NN_ORANGE_RISK',
    NnOrangeBonus: 'NN_ORANGE_BONUS',
    NnOrangeInvest: 'NN_ORANGE_INVEST',
    NnOrangeCare: 'NN_ORANGE_CARE',
    NnOrangeBenefit: 'NN_ORANGE_BENEFIT',
    NnFufiUl: 'NN_FUFI_UL',
    NnFufiUlSingle: 'NN_FUFI_UL_SINGLE',
    NnFufiPseudoRsk: 'NN_FUFI_PSEUDO_RSK'
} as const;

export type ProductNameType = typeof ProductNameType[keyof typeof ProductNameType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductType = {
    Ds: 'DS',
    Pf: 'PF',
    Uf: 'UF',
    Ts: 'TS',
    Cl: 'CL',
    Sl: 'SL',
    Clf: 'CLF',
    Na: 'NA'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];


/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {ProfileCode}
     * @memberof Profile
     */
    'code': ProfileCode;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProfileCode = {
    Rejected: 'REJECTED',
    Con: 'CON',
    Bal: 'BAL',
    Dyn: 'DYN'
} as const;

export type ProfileCode = typeof ProfileCode[keyof typeof ProfileCode];


/**
 * 
 * @export
 * @interface QuestionnaireConfig
 */
export interface QuestionnaireConfig {
    /**
     * 
     * @type {Array<QuestionnaireConfigFund>}
     * @memberof QuestionnaireConfig
     */
    'funds': Array<QuestionnaireConfigFund>;
    /**
     * 
     * @type {Array<QuestionnaireConfigInvestmentProfile>}
     * @memberof QuestionnaireConfig
     */
    'investmentProfiles': Array<QuestionnaireConfigInvestmentProfile>;
    /**
     * 
     * @type {Array<QuestionnaireConfigRecommendedStrategy>}
     * @memberof QuestionnaireConfig
     */
    'recommendedStrategies': Array<QuestionnaireConfigRecommendedStrategy>;
}
/**
 * 
 * @export
 * @interface QuestionnaireConfigFund
 */
export interface QuestionnaireConfigFund {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigFund
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigFund
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigFund
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigFund
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface QuestionnaireConfigInvestmentProfile
 */
export interface QuestionnaireConfigInvestmentProfile {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigInvestmentProfile
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigInvestmentProfile
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigInvestmentProfile
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface QuestionnaireConfigRecommendedStrategy
 */
export interface QuestionnaireConfigRecommendedStrategy {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategy
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigRecommendedStrategy
     */
    'name': string;
    /**
     * 
     * @type {Array<QuestionnaireConfigRecommendedStrategyFund>}
     * @memberof QuestionnaireConfigRecommendedStrategy
     */
    'funds': Array<QuestionnaireConfigRecommendedStrategyFund>;
}
/**
 * 
 * @export
 * @interface QuestionnaireConfigRecommendedStrategyFund
 */
export interface QuestionnaireConfigRecommendedStrategyFund {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategyFund
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategyFund
     */
    'maxPercentageAllocation': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategyFund
     */
    'recommendedPercentageAllocation': number;
}
/**
 * 
 * @export
 * @interface QuestionnaireEvaluateRequestAnswer
 */
export interface QuestionnaireEvaluateRequestAnswer {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateRequestAnswer
     */
    'questionId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionnaireEvaluateRequestAnswer
     */
    'answers': Array<string>;
}
/**
 * 
 * @export
 * @interface QuestionnaireEvaluateRequestAnswers
 */
export interface QuestionnaireEvaluateRequestAnswers {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    'rejected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    'isNewContract': boolean;
    /**
     * 
     * @type {Array<QuestionnaireEvaluateRequestAnswer>}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    'userAnswers': Array<QuestionnaireEvaluateRequestAnswer>;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    'sustainabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateRequestAnswers
     */
    'contractId': string;
}
/**
 * 
 * @export
 * @interface QuestionnaireEvaluateResult
 */
export interface QuestionnaireEvaluateResult {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireEvaluateResult
     */
    'profileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateResult
     */
    'recommendedSolution': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateResult
     */
    'explanation': string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireEvaluateResult
     */
    'recommendedStrategyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateResult
     */
    'correlationId'?: string | null;
}
/**
 * 
 * @export
 * @interface QuestionnairePossibleAnswer
 */
export interface QuestionnairePossibleAnswer {
    /**
     * 
     * @type {string}
     * @memberof QuestionnairePossibleAnswer
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnairePossibleAnswer
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnairePossibleAnswer
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnairePossibleAnswer
     */
    'text': string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnairePossibleAnswer
     */
    'excludeOthers': boolean;
}
/**
 * 
 * @export
 * @interface QuestionnaireQuestion
 */
export interface QuestionnaireQuestion {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestion
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireQuestion
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestion
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestion
     */
    'text'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireQuestion
     */
    'multipleAllowed': boolean;
    /**
     * 
     * @type {Array<QuestionnaireQuestionImage>}
     * @memberof QuestionnaireQuestion
     */
    'images'?: Array<QuestionnaireQuestionImage> | null;
    /**
     * 
     * @type {Array<QuestionnairePossibleAnswer>}
     * @memberof QuestionnaireQuestion
     */
    'answers'?: Array<QuestionnairePossibleAnswer> | null;
}
/**
 * 
 * @export
 * @interface QuestionnaireQuestionImage
 */
export interface QuestionnaireQuestionImage {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestionImage
     */
    'base64': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestionImage
     */
    'legend': string;
}
/**
 * 
 * @export
 * @interface QuestionnaireQuestions
 */
export interface QuestionnaireQuestions {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestions
     */
    'version': string;
    /**
     * 
     * @type {Array<QuestionnaireQuestion>}
     * @memberof QuestionnaireQuestions
     */
    'questions': Array<QuestionnaireQuestion>;
}
/**
 * 
 * @export
 * @interface Questions
 */
export interface Questions {
    /**
     * 
     * @type {number}
     * @memberof Questions
     */
    'minRequiredAnswers': number;
    /**
     * 
     * @type {string}
     * @memberof Questions
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Questions
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof Questions
     */
    'content': string;
    /**
     * 
     * @type {number}
     * @memberof Questions
     */
    'maxRequiredAnswers': number;
    /**
     * 
     * @type {Array<PossibleAnswer>}
     * @memberof Questions
     */
    'answers': Array<PossibleAnswer>;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const RegisterReasonCodes = {
    Valid: 0,
    DataNotTrustworthyForBankId: 1000,
    IncompleteBankIdData: 1001,
    UnableToFindClientByBirthNumber: 1404,
    DataNotTrustworthyForLocal: 1804,
    FailedContractNumberValidation: 1805,
    ElectronicContactsUnavailable: 1806,
    FailedLocalRegistrationValidation: 1807,
    DeletedByCallCenter: 2000,
    MpkNotValid: 3000,
    MultipleMpkPendingValidation: 3001,
    DataNotTrustworthyTryContractNumber: 9000,
    RegisterInProgressStep1: -1000,
    RegisterInProgressStep2: -999
} as const;

export type RegisterReasonCodes = typeof RegisterReasonCodes[keyof typeof RegisterReasonCodes];


/**
 * 
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'givenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'phoneNumber2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'birthdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'birth_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'registered_contract_number'?: string | null;
    /**
     * 
     * @type {AuthenticationSourceType}
     * @memberof RegisterRequest
     */
    'authenticationSource': AuthenticationSourceType;
}


/**
 * 
 * @export
 * @interface RegisterRequestV2
 */
export interface RegisterRequestV2 {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestV2
     */
    'registered_contract_number'?: string | null;
}
/**
 * 
 * @export
 * @interface RegisterResponse
 */
export interface RegisterResponse {
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof RegisterResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof RegisterResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'pid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'mpk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'reason_phrase': string;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponse
     */
    'reason_code': number;
}


/**
 * 
 * @export
 * @interface RegisterResponseV2
 */
export interface RegisterResponseV2 {
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof RegisterResponseV2
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof RegisterResponseV2
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponseV2
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponseV2
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    'mpk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseV2
     */
    'reason_phrase': string;
    /**
     * 
     * @type {RegisterReasonCodes}
     * @memberof RegisterResponseV2
     */
    'reason_code': RegisterReasonCodes;
}


/**
 * 
 * @export
 * @interface RegisterValidateLoginRequest
 */
export interface RegisterValidateLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterValidateLoginRequest
     */
    'cipher': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterValidateLoginRequest
     */
    'tag': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterValidateLoginRequest
     */
    'nonce': string;
}
/**
 * 
 * @export
 * @interface RegisteredUser
 */
export interface RegisteredUser {
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'mpk'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'creationType': string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'createdDateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof RegisteredUser
     */
    'lastSignInDate'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RequirementStatus = {
    New: 'New',
    Waiting: 'Waiting',
    Processed: 'Processed',
    Failed: 'Failed',
    Rejected: 'Rejected',
    TemporarilyStopped: 'TemporarilyStopped'
} as const;

export type RequirementStatus = typeof RequirementStatus[keyof typeof RequirementStatus];


/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'pid': string;
}
/**
 * 
 * @export
 * @interface Rider
 */
export interface Rider {
    /**
     * 
     * @type {string}
     * @memberof Rider
     */
    'riderId': string;
    /**
     * 
     * @type {string}
     * @memberof Rider
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Rider
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Rider
     */
    'validFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Rider
     */
    'validTo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Rider
     */
    'isMainRider': boolean;
    /**
     * 
     * @type {number}
     * @memberof Rider
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof Rider
     */
    'filePath'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveElectronicsContactsRequest
 */
export interface SaveElectronicsContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    'objectId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveElectronicsContactsRequest
     */
    'isEmailVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    'emailVerificationTimestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveElectronicsContactsRequest
     */
    'isPhoneVerified'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    'phoneVerificationTimestamp'?: string | null;
}
/**
 * 
 * @export
 * @interface SavePhoneNumberRequest
 */
export interface SavePhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof SavePhoneNumberRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SavePhoneNumberRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface SendAuthenticationSMSRequest
 */
export interface SendAuthenticationSMSRequest {
    /**
     * 
     * @type {string}
     * @memberof SendAuthenticationSMSRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface SendAuthenticationSMSResponse
 */
export interface SendAuthenticationSMSResponse {
    /**
     * 
     * @type {string}
     * @memberof SendAuthenticationSMSResponse
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof SendAuthenticationSMSResponse
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface SetAmlIdentificationRequest
 */
export interface SetAmlIdentificationRequest {
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'sourceOfIncome'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'companySourceOfIncome'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'sourceOfProperty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'income'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'domicil'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetAmlIdentificationRequest
     */
    'TaxNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetAmlIdentificationRequest
     */
    'pep'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetAmlIdentificationRequest
     */
    'greenCard'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetAmlIdentificationRequest
     */
    'usTaxResident'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SetBeneficiariesRequest
 */
export interface SetBeneficiariesRequest {
    /**
     * 
     * @type {Array<BeneficiaryRequest>}
     * @memberof SetBeneficiariesRequest
     */
    'beneficiaries': Array<BeneficiaryRequest>;
}
/**
 * 
 * @export
 * @interface SetConsentRequest
 */
export interface SetConsentRequest {
    /**
     * 
     * @type {ConsentType}
     * @memberof SetConsentRequest
     */
    'consentType': ConsentType;
    /**
     * 
     * @type {boolean}
     * @memberof SetConsentRequest
     */
    'consent': boolean;
}


/**
 * 
 * @export
 * @interface SetContributionRequest
 */
export interface SetContributionRequest {
    /**
     * 
     * @type {number}
     * @memberof SetContributionRequest
     */
    'contribution'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetContributionRequest
     */
    'doesEmployerContribute'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SetCookieConsentRequest
 */
export interface SetCookieConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof SetCookieConsentRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SetCookieConsentRequest
     */
    'expirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof SetCookieConsentRequest
     */
    'cookieConsent': string;
}
/**
 * 
 * @export
 * @interface SetDPSTaxOptimumRequest
 */
export interface SetDPSTaxOptimumRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetDPSTaxOptimumRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface SetInflationProgramRequest
 */
export interface SetInflationProgramRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetInflationProgramRequest
     */
    'inflation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetInflationProgramRequest
     */
    'gio'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SetPPTaxOptimumRequest
 */
export interface SetPPTaxOptimumRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetPPTaxOptimumRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface SetPensionBeneficiariesRequest
 */
export interface SetPensionBeneficiariesRequest {
    /**
     * 
     * @type {Array<PensionBeneficiary>}
     * @memberof SetPensionBeneficiariesRequest
     */
    'beneficiaries': Array<PensionBeneficiary>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SfdrPreference = {
    Yes: 'Yes',
    PartialYes: 'PartialYes',
    No: 'No'
} as const;

export type SfdrPreference = typeof SfdrPreference[keyof typeof SfdrPreference];


/**
 * 
 * @export
 * @interface SharedClient
 */
export interface SharedClient {
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'degreeBefore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'citizenship'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'degreeAfter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedClient
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {AMLVerification}
     * @memberof SharedClient
     */
    'identificationStatus': AMLVerification;
    /**
     * 
     * @type {IdentificationStatusNR}
     * @memberof SharedClient
     */
    'identificationStatusNR'?: IdentificationStatusNR;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const StarPensionClientTypeEnum = {
    Z: 'Z',
    P: 'P',
    S: 'S',
    N: 'N'
} as const;

export type StarPensionClientTypeEnum = typeof StarPensionClientTypeEnum[keyof typeof StarPensionClientTypeEnum];


/**
 * 
 * @export
 * @interface Strategy
 */
export interface Strategy {
    /**
     * 
     * @type {StrategyCode}
     * @memberof Strategy
     */
    'code': StrategyCode;
    /**
     * 
     * @type {string}
     * @memberof Strategy
     */
    'name': string;
    /**
     * 
     * @type {Array<Allocation>}
     * @memberof Strategy
     */
    'allocation': Array<Allocation>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const StrategyCode = {
    Rejected: 'REJECTED',
    Prepension: 'PREPENSION',
    Con: 'CON',
    Bal: 'BAL',
    Dyn: 'DYN'
} as const;

export type StrategyCode = typeof StrategyCode[keyof typeof StrategyCode];


/**
 * 
 * @export
 * @enum {string}
 */

export const TypeEnum = {
    Agent: 'Agent',
    Broker: 'Broker',
    Client: 'Client'
} as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];


/**
 * 
 * @export
 * @interface UpdateAuthorizationPropertyRequest
 */
export interface UpdateAuthorizationPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAuthorizationPropertyRequest
     */
    'mpk': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAuthorizationPropertyRequest
     */
    'value': string;
    /**
     * 
     * @type {ClientAuthorizationPropertyType}
     * @memberof UpdateAuthorizationPropertyRequest
     */
    'propertyType': ClientAuthorizationPropertyType;
}


/**
 * 
 * @export
 * @interface UpdateAuthorizationPropertyResponse
 */
export interface UpdateAuthorizationPropertyResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateAuthorizationPropertyResponse
     */
    'correlationId': string;
}
/**
 * 
 * @export
 * @interface UserAnswersRequest
 */
export interface UserAnswersRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UserAnswersRequest
     */
    'rejected': boolean;
    /**
     * 
     * @type {Array<PickedAnswerRequest>}
     * @memberof UserAnswersRequest
     */
    'answers': Array<PickedAnswerRequest>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserMessageSeverity = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error'
} as const;

export type UserMessageSeverity = typeof UserMessageSeverity[keyof typeof UserMessageSeverity];


/**
 * 
 * @export
 * @interface ValidateBirthNumberRequest
 */
export interface ValidateBirthNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberRequest
     */
    'birthdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberRequest
     */
    'birth_number'?: string | null;
    /**
     * 
     * @type {AuthenticationSourceType}
     * @memberof ValidateBirthNumberRequest
     */
    'authenticationSource': AuthenticationSourceType;
}


/**
 * 
 * @export
 * @interface ValidateBirthNumberResponse
 */
export interface ValidateBirthNumberResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof ValidateBirthNumberResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof ValidateBirthNumberResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof ValidateBirthNumberResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidateBirthNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberResponse
     */
    'birthdate': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberResponse
     */
    'birth_number': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateBirthNumberResponse
     */
    'numeric_birth_number': string;
}


/**
 * 
 * @export
 * @interface ValidateLocalAccountRequest
 */
export interface ValidateLocalAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateLocalAccountRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidateLocalAccountResponse
 */
export interface ValidateLocalAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateLocalAccountResponse
     */
    'version': string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof ValidateLocalAccountResponse
     */
    'action': ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof ValidateLocalAccountResponse
     */
    'userMessage'?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof ValidateLocalAccountResponse
     */
    'messageSeverity'?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof ValidateLocalAccountResponse
     */
    'status'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidateLocalAccountResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateLocalAccountResponse
     */
    'isAccountRegistered': boolean;
}


/**
 * 
 * @export
 * @interface ZZJInformationRequest
 */
export interface ZZJInformationRequest {
    /**
     * 
     * @type {UserAnswersRequest}
     * @memberof ZZJInformationRequest
     */
    'investmentQuestionnaire': UserAnswersRequest;
    /**
     * 
     * @type {ChangeResources}
     * @memberof ZZJInformationRequest
     */
    'existingResources'?: ChangeResources;
    /**
     * 
     * @type {ChangeResources}
     * @memberof ZZJInformationRequest
     */
    'newResources'?: ChangeResources;
    /**
     * 
     * @type {SfdrPreference}
     * @memberof ZZJInformationRequest
     */
    'sfdrPreference': SfdrPreference;
}



/**
 * AuthenticateApi - axios parameter creator
 * @export
 */
export const AuthenticateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get encrypted user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptUserIdGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authenticate/encrypt-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all phone numbers that can be used for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticationPhoneNumbersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authenticate/phone-numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends sms to picked phone number type
         * @param {SendAuthenticationSMSRequest} sendAuthenticationSMSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAuthenticationSMSPost: async (sendAuthenticationSMSRequest: SendAuthenticationSMSRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendAuthenticationSMSRequest' is not null or undefined
            assertParamExists('sendAuthenticationSMSPost', 'sendAuthenticationSMSRequest', sendAuthenticationSMSRequest)
            const localVarPath = `/authenticate/send-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAuthenticationSMSRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticateApi - functional programming interface
 * @export
 */
export const AuthenticateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get encrypted user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async encryptUserIdGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AesGcmEncryptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.encryptUserIdGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticateApi.encryptUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all phone numbers that can be used for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthenticationPhoneNumbersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthenticationPhoneNumbersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticateApi.getAuthenticationPhoneNumbersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sends sms to picked phone number type
         * @param {SendAuthenticationSMSRequest} sendAuthenticationSMSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAuthenticationSMSPost(sendAuthenticationSMSRequest: SendAuthenticationSMSRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendAuthenticationSMSResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAuthenticationSMSPost(sendAuthenticationSMSRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticateApi.sendAuthenticationSMSPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticateApi - factory interface
 * @export
 */
export const AuthenticateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticateApiFp(configuration)
    return {
        /**
         * 
         * @summary Get encrypted user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptUserIdGet(options?: RawAxiosRequestConfig): AxiosPromise<AesGcmEncryptResponse> {
            return localVarFp.encryptUserIdGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all phone numbers that can be used for authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthenticationPhoneNumbersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAuthenticationPhoneNumbersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends sms to picked phone number type
         * @param {SendAuthenticationSMSRequest} sendAuthenticationSMSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAuthenticationSMSPost(sendAuthenticationSMSRequest: SendAuthenticationSMSRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendAuthenticationSMSResponse> {
            return localVarFp.sendAuthenticationSMSPost(sendAuthenticationSMSRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticateApi - object-oriented interface
 * @export
 * @class AuthenticateApi
 * @extends {BaseAPI}
 */
export class AuthenticateApi extends BaseAPI {
    /**
     * 
     * @summary Get encrypted user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public encryptUserIdGet(options?: RawAxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).encryptUserIdGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all phone numbers that can be used for authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public getAuthenticationPhoneNumbersGet(options?: RawAxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).getAuthenticationPhoneNumbersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends sms to picked phone number type
     * @param {SendAuthenticationSMSRequest} sendAuthenticationSMSRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public sendAuthenticationSMSPost(sendAuthenticationSMSRequest: SendAuthenticationSMSRequest, options?: RawAxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).sendAuthenticationSMSPost(sendAuthenticationSMSRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BankIdApi - axios parameter creator
 * @export
 */
export const BankIdApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate ciper, tag, nonce
         * @param {BankIdValidateLoginRequest} [bankIdValidateLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginPost: async (bankIdValidateLoginRequest?: BankIdValidateLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bank-id/authorize-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankIdValidateLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Try login portal client by bank-id
         * @param {BankIdLoginPayloadRequest} [bankIdLoginPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processBankIdLoginCallbackPost: async (bankIdLoginPayloadRequest?: BankIdLoginPayloadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bank-id/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankIdLoginPayloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Try register portal client by bank-id
         * @param {BankIdRegisterPayloadRequest} [bankIdRegisterPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processBankIdRegisterPost: async (bankIdRegisterPayloadRequest?: BankIdRegisterPayloadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bank-id/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankIdRegisterPayloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankIdApi - functional programming interface
 * @export
 */
export const BankIdApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankIdApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Validate ciper, tag, nonce
         * @param {BankIdValidateLoginRequest} [bankIdValidateLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeLoginPost(bankIdValidateLoginRequest?: BankIdValidateLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeLoginPost(bankIdValidateLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankIdApi.authorizeLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Try login portal client by bank-id
         * @param {BankIdLoginPayloadRequest} [bankIdLoginPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processBankIdLoginCallbackPost(bankIdLoginPayloadRequest?: BankIdLoginPayloadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankIdCreateLoginPayloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processBankIdLoginCallbackPost(bankIdLoginPayloadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankIdApi.processBankIdLoginCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Try register portal client by bank-id
         * @param {BankIdRegisterPayloadRequest} [bankIdRegisterPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processBankIdRegisterPost(bankIdRegisterPayloadRequest?: BankIdRegisterPayloadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankIdCreateLoginPayloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processBankIdRegisterPost(bankIdRegisterPayloadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankIdApi.processBankIdRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BankIdApi - factory interface
 * @export
 */
export const BankIdApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankIdApiFp(configuration)
    return {
        /**
         * 
         * @summary Validate ciper, tag, nonce
         * @param {BankIdValidateLoginRequest} [bankIdValidateLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginPost(bankIdValidateLoginRequest?: BankIdValidateLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.authorizeLoginPost(bankIdValidateLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Try login portal client by bank-id
         * @param {BankIdLoginPayloadRequest} [bankIdLoginPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processBankIdLoginCallbackPost(bankIdLoginPayloadRequest?: BankIdLoginPayloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<BankIdCreateLoginPayloadResponse> {
            return localVarFp.processBankIdLoginCallbackPost(bankIdLoginPayloadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Try register portal client by bank-id
         * @param {BankIdRegisterPayloadRequest} [bankIdRegisterPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processBankIdRegisterPost(bankIdRegisterPayloadRequest?: BankIdRegisterPayloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<BankIdCreateLoginPayloadResponse> {
            return localVarFp.processBankIdRegisterPost(bankIdRegisterPayloadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankIdApi - object-oriented interface
 * @export
 * @class BankIdApi
 * @extends {BaseAPI}
 */
export class BankIdApi extends BaseAPI {
    /**
     * 
     * @summary Validate ciper, tag, nonce
     * @param {BankIdValidateLoginRequest} [bankIdValidateLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankIdApi
     */
    public authorizeLoginPost(bankIdValidateLoginRequest?: BankIdValidateLoginRequest, options?: RawAxiosRequestConfig) {
        return BankIdApiFp(this.configuration).authorizeLoginPost(bankIdValidateLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Try login portal client by bank-id
     * @param {BankIdLoginPayloadRequest} [bankIdLoginPayloadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankIdApi
     */
    public processBankIdLoginCallbackPost(bankIdLoginPayloadRequest?: BankIdLoginPayloadRequest, options?: RawAxiosRequestConfig) {
        return BankIdApiFp(this.configuration).processBankIdLoginCallbackPost(bankIdLoginPayloadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Try register portal client by bank-id
     * @param {BankIdRegisterPayloadRequest} [bankIdRegisterPayloadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankIdApi
     */
    public processBankIdRegisterPost(bankIdRegisterPayloadRequest?: BankIdRegisterPayloadRequest, options?: RawAxiosRequestConfig) {
        return BankIdApiFp(this.configuration).processBankIdRegisterPost(bankIdRegisterPayloadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BannersApi - axios parameter creator
 * @export
 */
export const BannersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get CMS info banners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsWarningsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/banners/cms-warnings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannersApi - functional programming interface
 * @export
 */
export const BannersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BannersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get CMS info banners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCmsWarningsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CmsWarningsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCmsWarningsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BannersApi.getCmsWarningsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BannersApi - factory interface
 * @export
 */
export const BannersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BannersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get CMS info banners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsWarningsGet(options?: RawAxiosRequestConfig): AxiosPromise<CmsWarningsResponse> {
            return localVarFp.getCmsWarningsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BannersApi - object-oriented interface
 * @export
 * @class BannersApi
 * @extends {BaseAPI}
 */
export class BannersApi extends BaseAPI {
    /**
     * 
     * @summary Get CMS info banners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public getCmsWarningsGet(options?: RawAxiosRequestConfig) {
        return BannersApiFp(this.configuration).getCmsWarningsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallCenterApi - axios parameter creator
 * @export
 */
export const CallCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign MasterKey to a Active Directory user.
         * @param {AssignMasterKeyRequest} assignMasterKeyRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignMasterKeyPatch: async (assignMasterKeyRequest: AssignMasterKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignMasterKeyRequest' is not null or undefined
            assertParamExists('assignMasterKeyPatch', 'assignMasterKeyRequest', assignMasterKeyRequest)
            const localVarPath = `/assign-masterkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignMasterKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign Pid to a Active Directory user.
         * @param {AssignPidRequest} assignPidRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignPidPatch: async (assignPidRequest: AssignPidRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignPidRequest' is not null or undefined
            assertParamExists('assignPidPatch', 'assignPidRequest', assignPidRequest)
            const localVarPath = `/assign-pid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignPidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change MPK for a registered user.
         * @param {ChangeMpkRequest} changeMpkRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        changeMpkPatch: async (changeMpkRequest: ChangeMpkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeMpkRequest' is not null or undefined
            assertParamExists('changeMpkPatch', 'changeMpkRequest', changeMpkRequest)
            const localVarPath = `/change-mpk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMpkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of current users.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdUsersGet: async (search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ad-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current authorization phone and email by MPK.
         * @param {string} [mpk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationDataGet: async (mpk?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authorization-property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)

            if (mpk !== undefined) {
                localVarQueryParameter['Mpk'] = mpk;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of Ndp clients based on search parameter.
         * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getNdpClientContractsPost: async (getNdpClientContractsRequest?: GetNdpClientContractsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ndp-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNdpClientContractsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of clients based on search parameter.
         * @param {string} [birthNumber] 
         * @param {string} [contractNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getODSClientsGet: async (birthNumber?: string, contractNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ods-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (birthNumber !== undefined) {
                localVarQueryParameter['birthNumber'] = birthNumber;
            }

            if (contractNumber !== undefined) {
                localVarQueryParameter['contractNumber'] = contractNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of registered users.
         * @param {string} [search] 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRegisteredUsersGet: async (search?: string, count?: number, pageNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registered-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get impersonated user from the registered table.
         * @param {ImpersonateUserRequest} [impersonateUserRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        impersonateUserPost: async (impersonateUserRequest?: ImpersonateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/impersonate-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(impersonateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove user from Active Directory
         * @param {string} userId Required object id of the Active Directory user
         * @param {string} [employeeId] Call center employee Id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        removeAdUserDelete: async (userId: string, employeeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeAdUserDelete', 'userId', userId)
            const localVarPath = `/ad-users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create authorization property change request by MPK.
         * @param {UpdateAuthorizationPropertyRequest} updateAuthorizationPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthorizationPropertyPatch: async (updateAuthorizationPropertyRequest: UpdateAuthorizationPropertyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAuthorizationPropertyRequest' is not null or undefined
            assertParamExists('updateAuthorizationPropertyPatch', 'updateAuthorizationPropertyRequest', updateAuthorizationPropertyRequest)
            const localVarPath = `/authorization-property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuthorizationPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterApi - functional programming interface
 * @export
 */
export const CallCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign MasterKey to a Active Directory user.
         * @param {AssignMasterKeyRequest} assignMasterKeyRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignMasterKeyPatch(assignMasterKeyRequest: AssignMasterKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignMasterKeyPatch(assignMasterKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.assignMasterKeyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign Pid to a Active Directory user.
         * @param {AssignPidRequest} assignPidRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignPidPatch(assignPidRequest: AssignPidRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPidPatch(assignPidRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.assignPidPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change MPK for a registered user.
         * @param {ChangeMpkRequest} changeMpkRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async changeMpkPatch(changeMpkRequest: ChangeMpkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeMpkPatch(changeMpkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.changeMpkPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of current users.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAdUsersGet(search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAdUsersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdUsersGet(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.getAdUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current authorization phone and email by MPK.
         * @param {string} [mpk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizationDataGet(mpk?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuthorizationDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizationDataGet(mpk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.getAuthorizationDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of Ndp clients based on search parameter.
         * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getNdpClientContractsPost(getNdpClientContractsRequest?: GetNdpClientContractsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNdpClientContractsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNdpClientContractsPost(getNdpClientContractsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.getNdpClientContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of clients based on search parameter.
         * @param {string} [birthNumber] 
         * @param {string} [contractNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getODSClientsGet(birthNumber?: string, contractNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetODSClientsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getODSClientsGet(birthNumber, contractNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.getODSClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of registered users.
         * @param {string} [search] 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getRegisteredUsersGet(search?: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegisteredUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegisteredUsersGet(search, count, pageNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.getRegisteredUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get impersonated user from the registered table.
         * @param {ImpersonateUserRequest} [impersonateUserRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async impersonateUserPost(impersonateUserRequest?: ImpersonateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateUserPost(impersonateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.impersonateUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove user from Active Directory
         * @param {string} userId Required object id of the Active Directory user
         * @param {string} [employeeId] Call center employee Id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async removeAdUserDelete(userId: string, employeeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAdUserDelete(userId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.removeAdUserDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create authorization property change request by MPK.
         * @param {UpdateAuthorizationPropertyRequest} updateAuthorizationPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAuthorizationPropertyPatch(updateAuthorizationPropertyRequest: UpdateAuthorizationPropertyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAuthorizationPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAuthorizationPropertyPatch(updateAuthorizationPropertyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterApi.updateAuthorizationPropertyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallCenterApi - factory interface
 * @export
 */
export const CallCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallCenterApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign MasterKey to a Active Directory user.
         * @param {AssignMasterKeyRequest} assignMasterKeyRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignMasterKeyPatch(assignMasterKeyRequest: AssignMasterKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignMasterKeyPatch(assignMasterKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign Pid to a Active Directory user.
         * @param {AssignPidRequest} assignPidRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignPidPatch(assignPidRequest: AssignPidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignPidPatch(assignPidRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change MPK for a registered user.
         * @param {ChangeMpkRequest} changeMpkRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        changeMpkPatch(changeMpkRequest: ChangeMpkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeMpkPatch(changeMpkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of current users.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdUsersGet(search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAdUsersResponse>> {
            return localVarFp.getAdUsersGet(search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current authorization phone and email by MPK.
         * @param {string} [mpk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationDataGet(mpk?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAuthorizationDataResponse> {
            return localVarFp.getAuthorizationDataGet(mpk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of Ndp clients based on search parameter.
         * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getNdpClientContractsPost(getNdpClientContractsRequest?: GetNdpClientContractsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetNdpClientContractsResponse>> {
            return localVarFp.getNdpClientContractsPost(getNdpClientContractsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of clients based on search parameter.
         * @param {string} [birthNumber] 
         * @param {string} [contractNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getODSClientsGet(birthNumber?: string, contractNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetODSClientsResponse>> {
            return localVarFp.getODSClientsGet(birthNumber, contractNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of registered users.
         * @param {string} [search] 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRegisteredUsersGet(search?: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetRegisteredUsersResponse> {
            return localVarFp.getRegisteredUsersGet(search, count, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get impersonated user from the registered table.
         * @param {ImpersonateUserRequest} [impersonateUserRequest] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        impersonateUserPost(impersonateUserRequest?: ImpersonateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.impersonateUserPost(impersonateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove user from Active Directory
         * @param {string} userId Required object id of the Active Directory user
         * @param {string} [employeeId] Call center employee Id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        removeAdUserDelete(userId: string, employeeId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeAdUserDelete(userId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create authorization property change request by MPK.
         * @param {UpdateAuthorizationPropertyRequest} updateAuthorizationPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthorizationPropertyPatch(updateAuthorizationPropertyRequest: UpdateAuthorizationPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateAuthorizationPropertyResponse> {
            return localVarFp.updateAuthorizationPropertyPatch(updateAuthorizationPropertyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallCenterApi - object-oriented interface
 * @export
 * @class CallCenterApi
 * @extends {BaseAPI}
 */
export class CallCenterApi extends BaseAPI {
    /**
     * 
     * @summary Assign MasterKey to a Active Directory user.
     * @param {AssignMasterKeyRequest} assignMasterKeyRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public assignMasterKeyPatch(assignMasterKeyRequest: AssignMasterKeyRequest, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).assignMasterKeyPatch(assignMasterKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign Pid to a Active Directory user.
     * @param {AssignPidRequest} assignPidRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public assignPidPatch(assignPidRequest: AssignPidRequest, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).assignPidPatch(assignPidRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change MPK for a registered user.
     * @param {ChangeMpkRequest} changeMpkRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public changeMpkPatch(changeMpkRequest: ChangeMpkRequest, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).changeMpkPatch(changeMpkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of current users.
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public getAdUsersGet(search?: string, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).getAdUsersGet(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current authorization phone and email by MPK.
     * @param {string} [mpk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public getAuthorizationDataGet(mpk?: string, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).getAuthorizationDataGet(mpk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of Ndp clients based on search parameter.
     * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public getNdpClientContractsPost(getNdpClientContractsRequest?: GetNdpClientContractsRequest, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).getNdpClientContractsPost(getNdpClientContractsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of clients based on search parameter.
     * @param {string} [birthNumber] 
     * @param {string} [contractNumber] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public getODSClientsGet(birthNumber?: string, contractNumber?: string, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).getODSClientsGet(birthNumber, contractNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of registered users.
     * @param {string} [search] 
     * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public getRegisteredUsersGet(search?: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).getRegisteredUsersGet(search, count, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get impersonated user from the registered table.
     * @param {ImpersonateUserRequest} [impersonateUserRequest] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public impersonateUserPost(impersonateUserRequest?: ImpersonateUserRequest, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).impersonateUserPost(impersonateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove user from Active Directory
     * @param {string} userId Required object id of the Active Directory user
     * @param {string} [employeeId] Call center employee Id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public removeAdUserDelete(userId: string, employeeId?: string, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).removeAdUserDelete(userId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create authorization property change request by MPK.
     * @param {UpdateAuthorizationPropertyRequest} updateAuthorizationPropertyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterApi
     */
    public updateAuthorizationPropertyPatch(updateAuthorizationPropertyRequest: UpdateAuthorizationPropertyRequest, options?: RawAxiosRequestConfig) {
        return CallCenterApiFp(this.configuration).updateAuthorizationPropertyPatch(updateAuthorizationPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallCenterV2Api - axios parameter creator
 * @export
 */
export const CallCenterV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change MPK for a registered user.
         * @param {ChangeMpkRequest} changeMpkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMpkV2Patch: async (changeMpkRequest: ChangeMpkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeMpkRequest' is not null or undefined
            assertParamExists('changeMpkV2Patch', 'changeMpkRequest', changeMpkRequest)
            const localVarPath = `/v2/change-mpk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMpkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of Ndp clients based on search parameter.
         * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNdpClientContractsV2Post: async (getNdpClientContractsRequest?: GetNdpClientContractsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ndp-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNdpClientContractsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of registered users.
         * @param {string} [search] 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisteredUsersV2Get: async (search?: string, count?: number, pageNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/registered-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sign-in history for a registered user.
         * @param {string} userId 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 20
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSignInHistoryV2Get: async (userId: string, count?: number, pageNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserSignInHistoryV2Get', 'userId', userId)
            const localVarPath = `/v2/registered-users/{userId}/sign-in-history`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get impersonated user from the registered table.
         * @param {ImpersonateUserRequest} [impersonateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateUserV2Post: async (impersonateUserRequest?: ImpersonateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/impersonate-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(impersonateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove user from Active Directory
         * @param {string} userId Required object id of the Active Directory user
         * @param {string} employeeId Call center employee Id
         * @param {string} employeeEmail Call center employee email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAdUserV2Delete: async (userId: string, employeeId: string, employeeEmail: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeAdUserV2Delete', 'userId', userId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('removeAdUserV2Delete', 'employeeId', employeeId)
            // verify required parameter 'employeeEmail' is not null or undefined
            assertParamExists('removeAdUserV2Delete', 'employeeEmail', employeeEmail)
            const localVarPath = `/v2/ad-users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication EntraIdCallCenterFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"], configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (employeeEmail !== undefined) {
                localVarQueryParameter['employeeEmail'] = employeeEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallCenterV2Api - functional programming interface
 * @export
 */
export const CallCenterV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallCenterV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change MPK for a registered user.
         * @param {ChangeMpkRequest} changeMpkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeMpkV2Patch(changeMpkRequest: ChangeMpkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeMpkV2Patch(changeMpkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterV2Api.changeMpkV2Patch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of Ndp clients based on search parameter.
         * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNdpClientContractsV2Post(getNdpClientContractsRequest?: GetNdpClientContractsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNdpClientContractsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNdpClientContractsV2Post(getNdpClientContractsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterV2Api.getNdpClientContractsV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of registered users.
         * @param {string} [search] 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegisteredUsersV2Get(search?: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegisteredUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegisteredUsersV2Get(search, count, pageNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterV2Api.getRegisteredUsersV2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sign-in history for a registered user.
         * @param {string} userId 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 20
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSignInHistoryV2Get(userId: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSignInHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSignInHistoryV2Get(userId, count, pageNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterV2Api.getUserSignInHistoryV2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get impersonated user from the registered table.
         * @param {ImpersonateUserRequest} [impersonateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonateUserV2Post(impersonateUserRequest?: ImpersonateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateUserV2Post(impersonateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterV2Api.impersonateUserV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove user from Active Directory
         * @param {string} userId Required object id of the Active Directory user
         * @param {string} employeeId Call center employee Id
         * @param {string} employeeEmail Call center employee email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAdUserV2Delete(userId: string, employeeId: string, employeeEmail: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallCenterAccountDeletionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAdUserV2Delete(userId, employeeId, employeeEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallCenterV2Api.removeAdUserV2Delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallCenterV2Api - factory interface
 * @export
 */
export const CallCenterV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallCenterV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Change MPK for a registered user.
         * @param {ChangeMpkRequest} changeMpkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMpkV2Patch(changeMpkRequest: ChangeMpkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeMpkV2Patch(changeMpkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of Ndp clients based on search parameter.
         * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNdpClientContractsV2Post(getNdpClientContractsRequest?: GetNdpClientContractsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetNdpClientContractsResponse>> {
            return localVarFp.getNdpClientContractsV2Post(getNdpClientContractsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of registered users.
         * @param {string} [search] 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisteredUsersV2Get(search?: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetRegisteredUsersResponse> {
            return localVarFp.getRegisteredUsersV2Get(search, count, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sign-in history for a registered user.
         * @param {string} userId 
         * @param {number} [count] Number of items in the response page.  Default &#x3D; 20
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSignInHistoryV2Get(userId: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetSignInHistoryResponse> {
            return localVarFp.getUserSignInHistoryV2Get(userId, count, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get impersonated user from the registered table.
         * @param {ImpersonateUserRequest} [impersonateUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateUserV2Post(impersonateUserRequest?: ImpersonateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.impersonateUserV2Post(impersonateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove user from Active Directory
         * @param {string} userId Required object id of the Active Directory user
         * @param {string} employeeId Call center employee Id
         * @param {string} employeeEmail Call center employee email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAdUserV2Delete(userId: string, employeeId: string, employeeEmail: string, options?: RawAxiosRequestConfig): AxiosPromise<CallCenterAccountDeletionResult> {
            return localVarFp.removeAdUserV2Delete(userId, employeeId, employeeEmail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallCenterV2Api - object-oriented interface
 * @export
 * @class CallCenterV2Api
 * @extends {BaseAPI}
 */
export class CallCenterV2Api extends BaseAPI {
    /**
     * 
     * @summary Change MPK for a registered user.
     * @param {ChangeMpkRequest} changeMpkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterV2Api
     */
    public changeMpkV2Patch(changeMpkRequest: ChangeMpkRequest, options?: RawAxiosRequestConfig) {
        return CallCenterV2ApiFp(this.configuration).changeMpkV2Patch(changeMpkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of Ndp clients based on search parameter.
     * @param {GetNdpClientContractsRequest} [getNdpClientContractsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterV2Api
     */
    public getNdpClientContractsV2Post(getNdpClientContractsRequest?: GetNdpClientContractsRequest, options?: RawAxiosRequestConfig) {
        return CallCenterV2ApiFp(this.configuration).getNdpClientContractsV2Post(getNdpClientContractsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of registered users.
     * @param {string} [search] 
     * @param {number} [count] Number of items in the response page.  Default &#x3D; 10
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterV2Api
     */
    public getRegisteredUsersV2Get(search?: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig) {
        return CallCenterV2ApiFp(this.configuration).getRegisteredUsersV2Get(search, count, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sign-in history for a registered user.
     * @param {string} userId 
     * @param {number} [count] Number of items in the response page.  Default &#x3D; 20
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterV2Api
     */
    public getUserSignInHistoryV2Get(userId: string, count?: number, pageNumber?: number, options?: RawAxiosRequestConfig) {
        return CallCenterV2ApiFp(this.configuration).getUserSignInHistoryV2Get(userId, count, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get impersonated user from the registered table.
     * @param {ImpersonateUserRequest} [impersonateUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterV2Api
     */
    public impersonateUserV2Post(impersonateUserRequest?: ImpersonateUserRequest, options?: RawAxiosRequestConfig) {
        return CallCenterV2ApiFp(this.configuration).impersonateUserV2Post(impersonateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove user from Active Directory
     * @param {string} userId Required object id of the Active Directory user
     * @param {string} employeeId Call center employee Id
     * @param {string} employeeEmail Call center employee email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCenterV2Api
     */
    public removeAdUserV2Delete(userId: string, employeeId: string, employeeEmail: string, options?: RawAxiosRequestConfig) {
        return CallCenterV2ApiFp(this.configuration).removeAdUserV2Delete(userId, employeeId, employeeEmail, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChangeRequestsApi - axios parameter creator
 * @export
 */
export const ChangeRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get change requests for the current user
         * @param {ChangeRequestType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangeRequestsGet: async (type?: ChangeRequestType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/changes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangeRequestsApi - functional programming interface
 * @export
 */
export const ChangeRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChangeRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get change requests for the current user
         * @param {ChangeRequestType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChangeRequestsGet(type?: ChangeRequestType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChangesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChangeRequestsGet(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChangeRequestsApi.getChangeRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChangeRequestsApi - factory interface
 * @export
 */
export const ChangeRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChangeRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get change requests for the current user
         * @param {ChangeRequestType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangeRequestsGet(type?: ChangeRequestType, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChangesResponse>> {
            return localVarFp.getChangeRequestsGet(type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChangeRequestsApi - object-oriented interface
 * @export
 * @class ChangeRequestsApi
 * @extends {BaseAPI}
 */
export class ChangeRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Get change requests for the current user
     * @param {ChangeRequestType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeRequestsApi
     */
    public getChangeRequestsGet(type?: ChangeRequestType, options?: RawAxiosRequestConfig) {
        return ChangeRequestsApiFp(this.configuration).getChangeRequestsGet(type, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConsentApi - axios parameter creator
 * @export
 */
export const ConsentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Checks whether consents confirmation should be shown or consents are proberly set for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areConsentsNeededGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/consents/required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get marketing consent setting for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set marketing consent setting for user
         * @param {SetConsentRequest} setConsentRequest Consent set to true means consent was given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConsentsPut: async (setConsentRequest: SetConsentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setConsentRequest' is not null or undefined
            assertParamExists('setConsentsPut', 'setConsentRequest', setConsentRequest)
            const localVarPath = `/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setConsentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set marketing cookie consent setting for user
         * @param {SetCookieConsentRequest} setCookieConsentRequest Specific cookie ids are passed in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCookiesConsentsPut: async (setCookieConsentRequest: SetCookieConsentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setCookieConsentRequest' is not null or undefined
            assertParamExists('setCookiesConsentsPut', 'setCookieConsentRequest', setCookieConsentRequest)
            const localVarPath = `/consents/cookies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCookieConsentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentApi - functional programming interface
 * @export
 */
export const ConsentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Checks whether consents confirmation should be shown or consents are proberly set for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areConsentsNeededGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AreConsentsNeededResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areConsentsNeededGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.areConsentsNeededGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get marketing consent setting for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConsentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.getConsentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set marketing consent setting for user
         * @param {SetConsentRequest} setConsentRequest Consent set to true means consent was given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setConsentsPut(setConsentRequest: SetConsentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setConsentsPut(setConsentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.setConsentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set marketing cookie consent setting for user
         * @param {SetCookieConsentRequest} setCookieConsentRequest Specific cookie ids are passed in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCookiesConsentsPut(setCookieConsentRequest: SetCookieConsentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCookiesConsentsPut(setCookieConsentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.setCookiesConsentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConsentApi - factory interface
 * @export
 */
export const ConsentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsentApiFp(configuration)
    return {
        /**
         * 
         * @summary Checks whether consents confirmation should be shown or consents are proberly set for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areConsentsNeededGet(options?: RawAxiosRequestConfig): AxiosPromise<AreConsentsNeededResponse> {
            return localVarFp.areConsentsNeededGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get marketing consent setting for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetConsentResponse>> {
            return localVarFp.getConsentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set marketing consent setting for user
         * @param {SetConsentRequest} setConsentRequest Consent set to true means consent was given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConsentsPut(setConsentRequest: SetConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setConsentsPut(setConsentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set marketing cookie consent setting for user
         * @param {SetCookieConsentRequest} setCookieConsentRequest Specific cookie ids are passed in a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCookiesConsentsPut(setCookieConsentRequest: SetCookieConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCookiesConsentsPut(setCookieConsentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentApi - object-oriented interface
 * @export
 * @class ConsentApi
 * @extends {BaseAPI}
 */
export class ConsentApi extends BaseAPI {
    /**
     * 
     * @summary Checks whether consents confirmation should be shown or consents are proberly set for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public areConsentsNeededGet(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).areConsentsNeededGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get marketing consent setting for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public getConsentsGet(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).getConsentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set marketing consent setting for user
     * @param {SetConsentRequest} setConsentRequest Consent set to true means consent was given
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public setConsentsPut(setConsentRequest: SetConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).setConsentsPut(setConsentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set marketing cookie consent setting for user
     * @param {SetCookieConsentRequest} setCookieConsentRequest Specific cookie ids are passed in a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public setCookiesConsentsPut(setCookieConsentRequest: SetCookieConsentRequest, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).setCookiesConsentsPut(setCookieConsentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contacts for all contracts of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContactsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get contacts for all contracts of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContactsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetContactsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContactsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getAllContactsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get contacts for all contracts of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContactsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetContactsResponse>> {
            return localVarFp.getAllContactsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * 
     * @summary Get contacts for all contracts of the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getAllContactsGet(options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getAllContactsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractsApi - axios parameter creator
 * @export
 */
export const ContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set inflation program for given contract
         * @param {string} contractId 
         * @param {SetInflationProgramRequest} setInflationProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInflationProgramPut: async (contractId: string, setInflationProgramRequest: SetInflationProgramRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('changeInflationProgramPut', 'contractId', contractId)
            // verify required parameter 'setInflationProgramRequest' is not null or undefined
            assertParamExists('changeInflationProgramPut', 'setInflationProgramRequest', setInflationProgramRequest)
            const localVarPath = `/contracts/{contractId}/change-inflation-program`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setInflationProgramRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of allowed changes for all contracts for a PID/MPK
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedChangesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contracts/allowed-changes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of contracts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Does contract belong to this portal
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isContractPresentGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('isContractPresentGet', 'contractId', contractId)
            const localVarPath = `/contracts/present/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsApi - functional programming interface
 * @export
 */
export const ContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set inflation program for given contract
         * @param {string} contractId 
         * @param {SetInflationProgramRequest} setInflationProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeInflationProgramPut(contractId: string, setInflationProgramRequest: SetInflationProgramRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeInflationProgramPut(contractId, setInflationProgramRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.changeInflationProgramPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of allowed changes for all contracts for a PID/MPK
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllowedChangesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllowedChangesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllowedChangesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.getAllowedChangesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of contracts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetContractsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.getContractsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Does contract belong to this portal
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isContractPresentGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsContractPresentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isContractPresentGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.isContractPresentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractsApi - factory interface
 * @export
 */
export const ContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsApiFp(configuration)
    return {
        /**
         * 
         * @summary Set inflation program for given contract
         * @param {string} contractId 
         * @param {SetInflationProgramRequest} setInflationProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInflationProgramPut(contractId: string, setInflationProgramRequest: SetInflationProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeInflationProgramPut(contractId, setInflationProgramRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of allowed changes for all contracts for a PID/MPK
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedChangesGet(options?: RawAxiosRequestConfig): AxiosPromise<GetAllowedChangesResponse> {
            return localVarFp.getAllowedChangesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of contracts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetContractsResponse>> {
            return localVarFp.getContractsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Does contract belong to this portal
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isContractPresentGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<IsContractPresentResponse> {
            return localVarFp.isContractPresentGet(contractId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractsApi - object-oriented interface
 * @export
 * @class ContractsApi
 * @extends {BaseAPI}
 */
export class ContractsApi extends BaseAPI {
    /**
     * 
     * @summary Set inflation program for given contract
     * @param {string} contractId 
     * @param {SetInflationProgramRequest} setInflationProgramRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public changeInflationProgramPut(contractId: string, setInflationProgramRequest: SetInflationProgramRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).changeInflationProgramPut(contractId, setInflationProgramRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of allowed changes for all contracts for a PID/MPK
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public getAllowedChangesGet(options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).getAllowedChangesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of contracts for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public getContractsGet(options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).getContractsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Does contract belong to this portal
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public isContractPresentGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).isContractPresentGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractsDpsApi - axios parameter creator
 * @export
 */
export const ContractsDpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change for funds on DPS
         * @param {string} contractId 
         * @param {ChangeFundsRequest} changeFundsRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        changeDPSFundsPost: async (contractId: string, changeFundsRequest: ChangeFundsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('changeDPSFundsPost', 'contractId', contractId)
            // verify required parameter 'changeFundsRequest' is not null or undefined
            assertParamExists('changeDPSFundsPost', 'changeFundsRequest', changeFundsRequest)
            const localVarPath = `/contracts/dps/{contractId}/change-funds`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeFundsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change for funds on DPS for the V2 Questionnaire
         * @param {string} contractId 
         * @param {ChangeFundsRequest} changeFundsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDPSFundsV2Post: async (contractId: string, changeFundsRequest: ChangeFundsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('changeDPSFundsV2Post', 'contractId', contractId)
            // verify required parameter 'changeFundsRequest' is not null or undefined
            assertParamExists('changeDPSFundsV2Post', 'changeFundsRequest', changeFundsRequest)
            const localVarPath = `/contracts/v2/dps/{contractId}/change-funds`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeFundsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get DPS contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSDetailGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getDPSDetailGet', 'contractId', contractId)
            const localVarPath = `/contracts/dps/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get historical values of pension units for funds included in a contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSFundsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getDPSFundsGet', 'contractId', contractId)
            const localVarPath = `/contracts/dps/{contractId}/funds`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get DPS transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
         * @param {string} [to] Default &#x3D; today
         * @param {Array<PensionTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSTransactionsGet: async (contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getDPSTransactionsGet', 'contractId', contractId)
            const localVarPath = `/contracts/dps/{contractId}/transactions`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (typeFilter) {
                localVarQueryParameter['TypeFilter'] = typeFilter.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get zzj pdf document
         * @param {string} contractId 
         * @param {ZZJInformationRequest} zZJInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDpsZzjPdfPost: async (contractId: string, zZJInformationRequest: ZZJInformationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getDpsZzjPdfPost', 'contractId', contractId)
            // verify required parameter 'zZJInformationRequest' is not null or undefined
            assertParamExists('getDpsZzjPdfPost', 'zZJInformationRequest', zZJInformationRequest)
            const localVarPath = `/contracts/dps/{contractId}/change-funds/zzj-pdf`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zZJInformationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download zzj preview
         * @param {string} contractId 
         * @param {GetZZJPreviewRequest} getZZJPreviewRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        previewChangeDPSFundsZZJPost: async (contractId: string, getZZJPreviewRequest: GetZZJPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('previewChangeDPSFundsZZJPost', 'contractId', contractId)
            // verify required parameter 'getZZJPreviewRequest' is not null or undefined
            assertParamExists('previewChangeDPSFundsZZJPost', 'getZZJPreviewRequest', getZZJPreviewRequest)
            const localVarPath = `/contracts/dps/{contractId}/change-funds/zzj-preview`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getZZJPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AML identification on DPS
         * @param {string} contractId 
         * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSAmlIdentificationPut: async (contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setDPSAmlIdentificationPut', 'contractId', contractId)
            // verify required parameter 'setAmlIdentificationRequest' is not null or undefined
            assertParamExists('setDPSAmlIdentificationPut', 'setAmlIdentificationRequest', setAmlIdentificationRequest)
            const localVarPath = `/contracts/dps/{contractId}/aml-identification`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAmlIdentificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set beneficiaries for DPS
         * @param {string} contractId 
         * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSBeneficiariesPut: async (contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setDPSBeneficiariesPut', 'contractId', contractId)
            // verify required parameter 'setPensionBeneficiariesRequest' is not null or undefined
            assertParamExists('setDPSBeneficiariesPut', 'setPensionBeneficiariesRequest', setPensionBeneficiariesRequest)
            const localVarPath = `/contracts/dps/{contractId}/beneficiaries`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPensionBeneficiariesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set contribution amount and does employer contribute for DPS
         * @param {string} contractId 
         * @param {SetContributionRequest} setContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSContributionPut: async (contractId: string, setContributionRequest: SetContributionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setDPSContributionPut', 'contractId', contractId)
            // verify required parameter 'setContributionRequest' is not null or undefined
            assertParamExists('setDPSContributionPut', 'setContributionRequest', setContributionRequest)
            const localVarPath = `/contracts/dps/{contractId}/contributions`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setContributionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change tax optimum on DPS
         * @param {string} contractId 
         * @param {SetDPSTaxOptimumRequest} setDPSTaxOptimumRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSTaxOptimumPut: async (contractId: string, setDPSTaxOptimumRequest: SetDPSTaxOptimumRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setDPSTaxOptimumPut', 'contractId', contractId)
            // verify required parameter 'setDPSTaxOptimumRequest' is not null or undefined
            assertParamExists('setDPSTaxOptimumPut', 'setDPSTaxOptimumRequest', setDPSTaxOptimumRequest)
            const localVarPath = `/contracts/dps/{contractId}/change-tax-optimum`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDPSTaxOptimumRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsDpsApi - functional programming interface
 * @export
 */
export const ContractsDpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsDpsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change for funds on DPS
         * @param {string} contractId 
         * @param {ChangeFundsRequest} changeFundsRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async changeDPSFundsPost(contractId: string, changeFundsRequest: ChangeFundsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeDPSFundsPost(contractId, changeFundsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.changeDPSFundsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change for funds on DPS for the V2 Questionnaire
         * @param {string} contractId 
         * @param {ChangeFundsRequest} changeFundsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeDPSFundsV2Post(contractId: string, changeFundsRequest: ChangeFundsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeDPSFundsV2Post(contractId, changeFundsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.changeDPSFundsV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get DPS contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDPSDetailGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDPSDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDPSDetailGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.getDPSDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get historical values of pension units for funds included in a contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDPSFundsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFundsPerformanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDPSFundsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.getDPSFundsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get DPS transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
         * @param {string} [to] Default &#x3D; today
         * @param {Array<PensionTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDPSTransactionsGet(contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPensionTransactionsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDPSTransactionsGet(contractId, count, from, to, typeFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.getDPSTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get zzj pdf document
         * @param {string} contractId 
         * @param {ZZJInformationRequest} zZJInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDpsZzjPdfPost(contractId: string, zZJInformationRequest: ZZJInformationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDpsZzjPdfPost(contractId, zZJInformationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.getDpsZzjPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download zzj preview
         * @param {string} contractId 
         * @param {GetZZJPreviewRequest} getZZJPreviewRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async previewChangeDPSFundsZZJPost(contractId: string, getZZJPreviewRequest: GetZZJPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewChangeDPSFundsZZJPost(contractId, getZZJPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.previewChangeDPSFundsZZJPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AML identification on DPS
         * @param {string} contractId 
         * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDPSAmlIdentificationPut(contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDPSAmlIdentificationPut(contractId, setAmlIdentificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.setDPSAmlIdentificationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set beneficiaries for DPS
         * @param {string} contractId 
         * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDPSBeneficiariesPut(contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDPSBeneficiariesPut(contractId, setPensionBeneficiariesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.setDPSBeneficiariesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set contribution amount and does employer contribute for DPS
         * @param {string} contractId 
         * @param {SetContributionRequest} setContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDPSContributionPut(contractId: string, setContributionRequest: SetContributionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDPSContributionPut(contractId, setContributionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.setDPSContributionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change tax optimum on DPS
         * @param {string} contractId 
         * @param {SetDPSTaxOptimumRequest} setDPSTaxOptimumRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDPSTaxOptimumPut(contractId: string, setDPSTaxOptimumRequest: SetDPSTaxOptimumRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDPSTaxOptimumPut(contractId, setDPSTaxOptimumRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsDpsApi.setDPSTaxOptimumPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractsDpsApi - factory interface
 * @export
 */
export const ContractsDpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsDpsApiFp(configuration)
    return {
        /**
         * 
         * @summary Change for funds on DPS
         * @param {string} contractId 
         * @param {ChangeFundsRequest} changeFundsRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        changeDPSFundsPost(contractId: string, changeFundsRequest: ChangeFundsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeDPSFundsPost(contractId, changeFundsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change for funds on DPS for the V2 Questionnaire
         * @param {string} contractId 
         * @param {ChangeFundsRequest} changeFundsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDPSFundsV2Post(contractId: string, changeFundsRequest: ChangeFundsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeDPSFundsV2Post(contractId, changeFundsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get DPS contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSDetailGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDPSDetailResponse> {
            return localVarFp.getDPSDetailGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get historical values of pension units for funds included in a contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSFundsGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetFundsPerformanceResponse>> {
            return localVarFp.getDPSFundsGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get DPS transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
         * @param {string} [to] Default &#x3D; today
         * @param {Array<PensionTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSTransactionsGet(contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPensionTransactionsResponse>> {
            return localVarFp.getDPSTransactionsGet(contractId, count, from, to, typeFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get zzj pdf document
         * @param {string} contractId 
         * @param {ZZJInformationRequest} zZJInformationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDpsZzjPdfPost(contractId: string, zZJInformationRequest: ZZJInformationRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getDpsZzjPdfPost(contractId, zZJInformationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download zzj preview
         * @param {string} contractId 
         * @param {GetZZJPreviewRequest} getZZJPreviewRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        previewChangeDPSFundsZZJPost(contractId: string, getZZJPreviewRequest: GetZZJPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.previewChangeDPSFundsZZJPost(contractId, getZZJPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AML identification on DPS
         * @param {string} contractId 
         * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSAmlIdentificationPut(contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDPSAmlIdentificationPut(contractId, setAmlIdentificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set beneficiaries for DPS
         * @param {string} contractId 
         * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSBeneficiariesPut(contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDPSBeneficiariesPut(contractId, setPensionBeneficiariesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set contribution amount and does employer contribute for DPS
         * @param {string} contractId 
         * @param {SetContributionRequest} setContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSContributionPut(contractId: string, setContributionRequest: SetContributionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDPSContributionPut(contractId, setContributionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change tax optimum on DPS
         * @param {string} contractId 
         * @param {SetDPSTaxOptimumRequest} setDPSTaxOptimumRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDPSTaxOptimumPut(contractId: string, setDPSTaxOptimumRequest: SetDPSTaxOptimumRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDPSTaxOptimumPut(contractId, setDPSTaxOptimumRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractsDpsApi - object-oriented interface
 * @export
 * @class ContractsDpsApi
 * @extends {BaseAPI}
 */
export class ContractsDpsApi extends BaseAPI {
    /**
     * 
     * @summary Change for funds on DPS
     * @param {string} contractId 
     * @param {ChangeFundsRequest} changeFundsRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public changeDPSFundsPost(contractId: string, changeFundsRequest: ChangeFundsRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).changeDPSFundsPost(contractId, changeFundsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change for funds on DPS for the V2 Questionnaire
     * @param {string} contractId 
     * @param {ChangeFundsRequest} changeFundsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public changeDPSFundsV2Post(contractId: string, changeFundsRequest: ChangeFundsRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).changeDPSFundsV2Post(contractId, changeFundsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get DPS contract detail for the current user
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public getDPSDetailGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).getDPSDetailGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get historical values of pension units for funds included in a contract
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public getDPSFundsGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).getDPSFundsGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get DPS transaction history.
     * @param {string} contractId 
     * @param {number} [count] Default &#x3D; 10
     * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
     * @param {string} [to] Default &#x3D; today
     * @param {Array<PensionTransactionEnum>} [typeFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public getDPSTransactionsGet(contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).getDPSTransactionsGet(contractId, count, from, to, typeFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get zzj pdf document
     * @param {string} contractId 
     * @param {ZZJInformationRequest} zZJInformationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public getDpsZzjPdfPost(contractId: string, zZJInformationRequest: ZZJInformationRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).getDpsZzjPdfPost(contractId, zZJInformationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download zzj preview
     * @param {string} contractId 
     * @param {GetZZJPreviewRequest} getZZJPreviewRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public previewChangeDPSFundsZZJPost(contractId: string, getZZJPreviewRequest: GetZZJPreviewRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).previewChangeDPSFundsZZJPost(contractId, getZZJPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AML identification on DPS
     * @param {string} contractId 
     * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public setDPSAmlIdentificationPut(contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).setDPSAmlIdentificationPut(contractId, setAmlIdentificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set beneficiaries for DPS
     * @param {string} contractId 
     * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public setDPSBeneficiariesPut(contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).setDPSBeneficiariesPut(contractId, setPensionBeneficiariesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set contribution amount and does employer contribute for DPS
     * @param {string} contractId 
     * @param {SetContributionRequest} setContributionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public setDPSContributionPut(contractId: string, setContributionRequest: SetContributionRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).setDPSContributionPut(contractId, setContributionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change tax optimum on DPS
     * @param {string} contractId 
     * @param {SetDPSTaxOptimumRequest} setDPSTaxOptimumRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsDpsApi
     */
    public setDPSTaxOptimumPut(contractId: string, setDPSTaxOptimumRequest: SetDPSTaxOptimumRequest, options?: RawAxiosRequestConfig) {
        return ContractsDpsApiFp(this.configuration).setDPSTaxOptimumPut(contractId, setDPSTaxOptimumRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractsLifeApi - axios parameter creator
 * @export
 */
export const ContractsLifeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Life contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeDetailGet', 'contractId', contractId)
            const localVarPath = `/contracts/life/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Life contract detail for the current user v2 using NDP data
         * @param {string} contractId 
         * @param {string} [proposalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailV2NdpGet: async (contractId: string, proposalNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeDetailV2NdpGet', 'contractId', contractId)
            const localVarPath = `/contracts/v2/life/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)

            if (proposalNumber !== undefined) {
                localVarQueryParameter['proposalNumber'] = proposalNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get FuFi financial info.
         * @param {string} contractId 
         * @param {FufiFinancialInfoQuery} [fufiFinancialInfoQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFufiFinancialInfoPost: async (contractId: string, fufiFinancialInfoQuery?: FufiFinancialInfoQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeFufiFinancialInfoPost', 'contractId', contractId)
            const localVarPath = `/contracts/life/fufi/{contractId}/financial-info`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fufiFinancialInfoQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get FuFi investments.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFufiInvestmentsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeFufiInvestmentsGet', 'contractId', contractId)
            const localVarPath = `/contracts/life/fufi/{contractId}/investments`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get historical values of fund units for a life contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFundsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeFundsGet', 'contractId', contractId)
            const localVarPath = `/contracts/life/{contractId}/funds`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Life transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] 
         * @param {string} [to] Default &#x3D; today
         * @param {ProductType} [productType] 
         * @param {Array<LifeTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeTransactionsGet: async (contractId: string, count?: number, from?: string, to?: string, productType?: ProductType, typeFilter?: Array<LifeTransactionEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeTransactionsGet', 'contractId', contractId)
            const localVarPath = `/contracts/life/{contractId}/transactions`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (productType !== undefined) {
                localVarQueryParameter['ProductType'] = productType;
            }

            if (typeFilter) {
                localVarQueryParameter['TypeFilter'] = typeFilter.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set beneficiaries for life
         * @param {string} contractId 
         * @param {SetBeneficiariesRequest} setBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLifeBeneficiariesPut: async (contractId: string, setBeneficiariesRequest: SetBeneficiariesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setLifeBeneficiariesPut', 'contractId', contractId)
            // verify required parameter 'setBeneficiariesRequest' is not null or undefined
            assertParamExists('setLifeBeneficiariesPut', 'setBeneficiariesRequest', setBeneficiariesRequest)
            const localVarPath = `/contracts/life/{contractId}/beneficiaries`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setBeneficiariesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsLifeApi - functional programming interface
 * @export
 */
export const ContractsLifeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsLifeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Life contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeDetailGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLifeDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeDetailGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.getLifeDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Life contract detail for the current user v2 using NDP data
         * @param {string} contractId 
         * @param {string} [proposalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeDetailV2NdpGet(contractId: string, proposalNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLifeDetailV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeDetailV2NdpGet(contractId, proposalNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.getLifeDetailV2NdpGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get FuFi financial info.
         * @param {string} contractId 
         * @param {FufiFinancialInfoQuery} [fufiFinancialInfoQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeFufiFinancialInfoPost(contractId: string, fufiFinancialInfoQuery?: FufiFinancialInfoQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FufiFinancialInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeFufiFinancialInfoPost(contractId, fufiFinancialInfoQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.getLifeFufiFinancialInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get FuFi investments.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeFufiInvestmentsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFufiInvestmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeFufiInvestmentsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.getLifeFufiInvestmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get historical values of fund units for a life contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeFundsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFundsPerformanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeFundsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.getLifeFundsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Life transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] 
         * @param {string} [to] Default &#x3D; today
         * @param {ProductType} [productType] 
         * @param {Array<LifeTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeTransactionsGet(contractId: string, count?: number, from?: string, to?: string, productType?: ProductType, typeFilter?: Array<LifeTransactionEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLifeTransactionsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeTransactionsGet(contractId, count, from, to, productType, typeFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.getLifeTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set beneficiaries for life
         * @param {string} contractId 
         * @param {SetBeneficiariesRequest} setBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setLifeBeneficiariesPut(contractId: string, setBeneficiariesRequest: SetBeneficiariesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setLifeBeneficiariesPut(contractId, setBeneficiariesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsLifeApi.setLifeBeneficiariesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractsLifeApi - factory interface
 * @export
 */
export const ContractsLifeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsLifeApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Life contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetLifeDetailResponse> {
            return localVarFp.getLifeDetailGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Life contract detail for the current user v2 using NDP data
         * @param {string} contractId 
         * @param {string} [proposalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailV2NdpGet(contractId: string, proposalNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetLifeDetailV2Response> {
            return localVarFp.getLifeDetailV2NdpGet(contractId, proposalNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get FuFi financial info.
         * @param {string} contractId 
         * @param {FufiFinancialInfoQuery} [fufiFinancialInfoQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFufiFinancialInfoPost(contractId: string, fufiFinancialInfoQuery?: FufiFinancialInfoQuery, options?: RawAxiosRequestConfig): AxiosPromise<FufiFinancialInfoResponse> {
            return localVarFp.getLifeFufiFinancialInfoPost(contractId, fufiFinancialInfoQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get FuFi investments.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFufiInvestmentsGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetFufiInvestmentsResponse> {
            return localVarFp.getLifeFufiInvestmentsGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get historical values of fund units for a life contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFundsGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetFundsPerformanceResponse>> {
            return localVarFp.getLifeFundsGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Life transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] 
         * @param {string} [to] Default &#x3D; today
         * @param {ProductType} [productType] 
         * @param {Array<LifeTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeTransactionsGet(contractId: string, count?: number, from?: string, to?: string, productType?: ProductType, typeFilter?: Array<LifeTransactionEnum>, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetLifeTransactionsResponse>> {
            return localVarFp.getLifeTransactionsGet(contractId, count, from, to, productType, typeFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set beneficiaries for life
         * @param {string} contractId 
         * @param {SetBeneficiariesRequest} setBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLifeBeneficiariesPut(contractId: string, setBeneficiariesRequest: SetBeneficiariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setLifeBeneficiariesPut(contractId, setBeneficiariesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractsLifeApi - object-oriented interface
 * @export
 * @class ContractsLifeApi
 * @extends {BaseAPI}
 */
export class ContractsLifeApi extends BaseAPI {
    /**
     * 
     * @summary Get Life contract detail for the current user
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public getLifeDetailGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).getLifeDetailGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Life contract detail for the current user v2 using NDP data
     * @param {string} contractId 
     * @param {string} [proposalNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public getLifeDetailV2NdpGet(contractId: string, proposalNumber?: string, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).getLifeDetailV2NdpGet(contractId, proposalNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get FuFi financial info.
     * @param {string} contractId 
     * @param {FufiFinancialInfoQuery} [fufiFinancialInfoQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public getLifeFufiFinancialInfoPost(contractId: string, fufiFinancialInfoQuery?: FufiFinancialInfoQuery, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).getLifeFufiFinancialInfoPost(contractId, fufiFinancialInfoQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get FuFi investments.
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public getLifeFufiInvestmentsGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).getLifeFufiInvestmentsGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get historical values of fund units for a life contract
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public getLifeFundsGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).getLifeFundsGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Life transaction history.
     * @param {string} contractId 
     * @param {number} [count] Default &#x3D; 10
     * @param {string} [from] 
     * @param {string} [to] Default &#x3D; today
     * @param {ProductType} [productType] 
     * @param {Array<LifeTransactionEnum>} [typeFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public getLifeTransactionsGet(contractId: string, count?: number, from?: string, to?: string, productType?: ProductType, typeFilter?: Array<LifeTransactionEnum>, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).getLifeTransactionsGet(contractId, count, from, to, productType, typeFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set beneficiaries for life
     * @param {string} contractId 
     * @param {SetBeneficiariesRequest} setBeneficiariesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsLifeApi
     */
    public setLifeBeneficiariesPut(contractId: string, setBeneficiariesRequest: SetBeneficiariesRequest, options?: RawAxiosRequestConfig) {
        return ContractsLifeApiFp(this.configuration).setLifeBeneficiariesPut(contractId, setBeneficiariesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractsPpApi - axios parameter creator
 * @export
 */
export const ContractsPpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get PP contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPPDetailGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getPPDetailGet', 'contractId', contractId)
            const localVarPath = `/contracts/pp/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get PP transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
         * @param {string} [to] Default &#x3D; today
         * @param {Array<PensionTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPPTransactionsGet: async (contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getPPTransactionsGet', 'contractId', contractId)
            const localVarPath = `/contracts/pp/{contractId}/transactions`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (typeFilter) {
                localVarQueryParameter['TypeFilter'] = typeFilter.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AML identification on PP
         * @param {string} contractId 
         * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPAmlIdentificationPut: async (contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setPPAmlIdentificationPut', 'contractId', contractId)
            // verify required parameter 'setAmlIdentificationRequest' is not null or undefined
            assertParamExists('setPPAmlIdentificationPut', 'setAmlIdentificationRequest', setAmlIdentificationRequest)
            const localVarPath = `/contracts/pp/{contractId}/aml-identification`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAmlIdentificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set beneficiaries for PP
         * @param {string} contractId 
         * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPBeneficiariesPut: async (contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setPPBeneficiariesPut', 'contractId', contractId)
            // verify required parameter 'setPensionBeneficiariesRequest' is not null or undefined
            assertParamExists('setPPBeneficiariesPut', 'setPensionBeneficiariesRequest', setPensionBeneficiariesRequest)
            const localVarPath = `/contracts/pp/{contractId}/beneficiaries`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPensionBeneficiariesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set contribution amount and does employer contribute for PP
         * @param {string} contractId 
         * @param {SetContributionRequest} setContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPContributionPut: async (contractId: string, setContributionRequest: SetContributionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setPPContributionPut', 'contractId', contractId)
            // verify required parameter 'setContributionRequest' is not null or undefined
            assertParamExists('setPPContributionPut', 'setContributionRequest', setContributionRequest)
            const localVarPath = `/contracts/pp/{contractId}/contributions`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setContributionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change tax optimum on PP
         * @param {string} contractId 
         * @param {SetPPTaxOptimumRequest} setPPTaxOptimumRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPTaxOptimumPut: async (contractId: string, setPPTaxOptimumRequest: SetPPTaxOptimumRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('setPPTaxOptimumPut', 'contractId', contractId)
            // verify required parameter 'setPPTaxOptimumRequest' is not null or undefined
            assertParamExists('setPPTaxOptimumPut', 'setPPTaxOptimumRequest', setPPTaxOptimumRequest)
            const localVarPath = `/contracts/pp/{contractId}/change-tax-optimum`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPPTaxOptimumRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsPpApi - functional programming interface
 * @export
 */
export const ContractsPpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsPpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get PP contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPPDetailGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPPDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPPDetailGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsPpApi.getPPDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get PP transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
         * @param {string} [to] Default &#x3D; today
         * @param {Array<PensionTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPPTransactionsGet(contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPensionTransactionsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPPTransactionsGet(contractId, count, from, to, typeFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsPpApi.getPPTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AML identification on PP
         * @param {string} contractId 
         * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPPAmlIdentificationPut(contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPPAmlIdentificationPut(contractId, setAmlIdentificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsPpApi.setPPAmlIdentificationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set beneficiaries for PP
         * @param {string} contractId 
         * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPPBeneficiariesPut(contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPPBeneficiariesPut(contractId, setPensionBeneficiariesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsPpApi.setPPBeneficiariesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set contribution amount and does employer contribute for PP
         * @param {string} contractId 
         * @param {SetContributionRequest} setContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPPContributionPut(contractId: string, setContributionRequest: SetContributionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPPContributionPut(contractId, setContributionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsPpApi.setPPContributionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change tax optimum on PP
         * @param {string} contractId 
         * @param {SetPPTaxOptimumRequest} setPPTaxOptimumRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPPTaxOptimumPut(contractId: string, setPPTaxOptimumRequest: SetPPTaxOptimumRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPPTaxOptimumPut(contractId, setPPTaxOptimumRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsPpApi.setPPTaxOptimumPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractsPpApi - factory interface
 * @export
 */
export const ContractsPpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsPpApiFp(configuration)
    return {
        /**
         * 
         * @summary Get PP contract detail for the current user
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPPDetailGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPPDetailResponse> {
            return localVarFp.getPPDetailGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get PP transaction history.
         * @param {string} contractId 
         * @param {number} [count] Default &#x3D; 10
         * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
         * @param {string} [to] Default &#x3D; today
         * @param {Array<PensionTransactionEnum>} [typeFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPPTransactionsGet(contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPensionTransactionsResponse>> {
            return localVarFp.getPPTransactionsGet(contractId, count, from, to, typeFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AML identification on PP
         * @param {string} contractId 
         * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPAmlIdentificationPut(contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPPAmlIdentificationPut(contractId, setAmlIdentificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set beneficiaries for PP
         * @param {string} contractId 
         * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPBeneficiariesPut(contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPPBeneficiariesPut(contractId, setPensionBeneficiariesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set contribution amount and does employer contribute for PP
         * @param {string} contractId 
         * @param {SetContributionRequest} setContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPContributionPut(contractId: string, setContributionRequest: SetContributionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPPContributionPut(contractId, setContributionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change tax optimum on PP
         * @param {string} contractId 
         * @param {SetPPTaxOptimumRequest} setPPTaxOptimumRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPPTaxOptimumPut(contractId: string, setPPTaxOptimumRequest: SetPPTaxOptimumRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPPTaxOptimumPut(contractId, setPPTaxOptimumRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractsPpApi - object-oriented interface
 * @export
 * @class ContractsPpApi
 * @extends {BaseAPI}
 */
export class ContractsPpApi extends BaseAPI {
    /**
     * 
     * @summary Get PP contract detail for the current user
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsPpApi
     */
    public getPPDetailGet(contractId: string, options?: RawAxiosRequestConfig) {
        return ContractsPpApiFp(this.configuration).getPPDetailGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get PP transaction history.
     * @param {string} contractId 
     * @param {number} [count] Default &#x3D; 10
     * @param {string} [from] Default &#x3D; today-1y, Must be before \&#39;to\&#39; date
     * @param {string} [to] Default &#x3D; today
     * @param {Array<PensionTransactionEnum>} [typeFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsPpApi
     */
    public getPPTransactionsGet(contractId: string, count?: number, from?: string, to?: string, typeFilter?: Array<PensionTransactionEnum>, options?: RawAxiosRequestConfig) {
        return ContractsPpApiFp(this.configuration).getPPTransactionsGet(contractId, count, from, to, typeFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AML identification on PP
     * @param {string} contractId 
     * @param {SetAmlIdentificationRequest} setAmlIdentificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsPpApi
     */
    public setPPAmlIdentificationPut(contractId: string, setAmlIdentificationRequest: SetAmlIdentificationRequest, options?: RawAxiosRequestConfig) {
        return ContractsPpApiFp(this.configuration).setPPAmlIdentificationPut(contractId, setAmlIdentificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set beneficiaries for PP
     * @param {string} contractId 
     * @param {SetPensionBeneficiariesRequest} setPensionBeneficiariesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsPpApi
     */
    public setPPBeneficiariesPut(contractId: string, setPensionBeneficiariesRequest: SetPensionBeneficiariesRequest, options?: RawAxiosRequestConfig) {
        return ContractsPpApiFp(this.configuration).setPPBeneficiariesPut(contractId, setPensionBeneficiariesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set contribution amount and does employer contribute for PP
     * @param {string} contractId 
     * @param {SetContributionRequest} setContributionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsPpApi
     */
    public setPPContributionPut(contractId: string, setContributionRequest: SetContributionRequest, options?: RawAxiosRequestConfig) {
        return ContractsPpApiFp(this.configuration).setPPContributionPut(contractId, setContributionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change tax optimum on PP
     * @param {string} contractId 
     * @param {SetPPTaxOptimumRequest} setPPTaxOptimumRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsPpApi
     */
    public setPPTaxOptimumPut(contractId: string, setPPTaxOptimumRequest: SetPPTaxOptimumRequest, options?: RawAxiosRequestConfig) {
        return ContractsPpApiFp(this.configuration).setPPTaxOptimumPut(contractId, setPPTaxOptimumRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevOnlyApi - axios parameter creator
 * @export
 */
export const DevOnlyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of contracts for a PID.
         * @param {number} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractsByPidGet: async (pid: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('getContractsByPidGet', 'pid', pid)
            const localVarPath = `/contracts/{pid}`
                .replace(`{${"pid"}}`, encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get PID from contractID
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPIDFromContractIdGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getPIDFromContractIdGet', 'contractId', contractId)
            const localVarPath = `/contracts/get-pid/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevOnlyApi - functional programming interface
 * @export
 */
export const DevOnlyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevOnlyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of contracts for a PID.
         * @param {number} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractsByPidGet(pid: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetContractsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractsByPidGet(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevOnlyApi.getContractsByPidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get PID from contractID
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPIDFromContractIdGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPIDFromContractIdGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevOnlyApi.getPIDFromContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevOnlyApi - factory interface
 * @export
 */
export const DevOnlyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevOnlyApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of contracts for a PID.
         * @param {number} pid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractsByPidGet(pid: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetContractsResponse>> {
            return localVarFp.getContractsByPidGet(pid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get PID from contractID
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPIDFromContractIdGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.getPIDFromContractIdGet(contractId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevOnlyApi - object-oriented interface
 * @export
 * @class DevOnlyApi
 * @extends {BaseAPI}
 */
export class DevOnlyApi extends BaseAPI {
    /**
     * 
     * @summary Get list of contracts for a PID.
     * @param {number} pid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevOnlyApi
     */
    public getContractsByPidGet(pid: number, options?: RawAxiosRequestConfig) {
        return DevOnlyApiFp(this.configuration).getContractsByPidGet(pid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get PID from contractID
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevOnlyApi
     */
    public getPIDFromContractIdGet(contractId: string, options?: RawAxiosRequestConfig) {
        return DevOnlyApiFp(this.configuration).getPIDFromContractIdGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download life-policy document
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLifePolicyDocumentGet: async (documentName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentName' is not null or undefined
            assertParamExists('downloadLifePolicyDocumentGet', 'documentName', documentName)
            const localVarPath = `/documents/download/life-policies/{documentName}`
                .replace(`{${"documentName"}}`, encodeURIComponent(String(documentName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Current DPS Pre-contractual Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentDPSPrecontractualInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/documents/current-dps-precontractual-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of documents for the given DPS contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSDocumentsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getDPSDocumentsGet', 'contractId', contractId)
            const localVarPath = `/documents/dps/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download specified document
         * @param {number} documentId 
         * @param {string} [token] 
         * @param {ProductType} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentGet: async (documentId: number, token?: string, productType?: ProductType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentGet', 'documentId', documentId)
            const localVarPath = `/documents/download/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of documents for the given life contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDocumentsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getLifeDocumentsGet', 'contractId', contractId)
            const localVarPath = `/documents/life/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of documents for the given fufi life contract.
         * @param {string} proposalNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFufiDocumentsGet: async (proposalNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalNumber' is not null or undefined
            assertParamExists('getLifeFufiDocumentsGet', 'proposalNumber', proposalNumber)
            const localVarPath = `/documents/life/fufi/{proposalNumber}`
                .replace(`{${"proposalNumber"}}`, encodeURIComponent(String(proposalNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of documents for the given PP contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPPDocumentsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('getPPDocumentsGet', 'contractId', contractId)
            const localVarPath = `/documents/pp/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of documents for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDocumentsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Head request to preflight a download of a specified document
         * @param {number} documentId 
         * @param {string} [token] 
         * @param {ProductType} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headDocumentHead: async (documentId: number, token?: string, productType?: ProductType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('headDocumentHead', 'documentId', documentId)
            const localVarPath = `/documents/download/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download life-policy document
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadLifePolicyDocumentGet(documentName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadLifePolicyDocumentGet(documentName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.downloadLifePolicyDocumentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Current DPS Pre-contractual Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentDPSPrecontractualInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDownloadInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentDPSPrecontractualInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getCurrentDPSPrecontractualInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of documents for the given DPS contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDPSDocumentsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDownloadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDPSDocumentsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDPSDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download specified document
         * @param {number} documentId 
         * @param {string} [token] 
         * @param {ProductType} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentGet(documentId: number, token?: string, productType?: ProductType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentGet(documentId, token, productType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of documents for the given life contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeDocumentsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDownloadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeDocumentsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getLifeDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of documents for the given fufi life contract.
         * @param {string} proposalNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeFufiDocumentsGet(proposalNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDownloadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeFufiDocumentsGet(proposalNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getLifeFufiDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of documents for the given PP contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPPDocumentsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDownloadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPPDocumentsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getPPDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of documents for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDocumentsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDownloadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDocumentsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getUserDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Head request to preflight a download of a specified document
         * @param {number} documentId 
         * @param {string} [token] 
         * @param {ProductType} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async headDocumentHead(documentId: number, token?: string, productType?: ProductType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.headDocumentHead(documentId, token, productType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.headDocumentHead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Download life-policy document
         * @param {string} documentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLifePolicyDocumentGet(documentName: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadLifePolicyDocumentGet(documentName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Current DPS Pre-contractual Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentDPSPrecontractualInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<FileDownloadInfo> {
            return localVarFp.getCurrentDPSPrecontractualInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of documents for the given DPS contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPSDocumentsGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDownloadResponse>> {
            return localVarFp.getDPSDocumentsGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download specified document
         * @param {number} documentId 
         * @param {string} [token] 
         * @param {ProductType} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentGet(documentId: number, token?: string, productType?: ProductType, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getDocumentGet(documentId, token, productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of documents for the given life contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDocumentsGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDownloadResponse>> {
            return localVarFp.getLifeDocumentsGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of documents for the given fufi life contract.
         * @param {string} proposalNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeFufiDocumentsGet(proposalNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDownloadResponse>> {
            return localVarFp.getLifeFufiDocumentsGet(proposalNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of documents for the given PP contract.
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPPDocumentsGet(contractId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDownloadResponse>> {
            return localVarFp.getPPDocumentsGet(contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of documents for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDocumentsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDownloadResponse>> {
            return localVarFp.getUserDocumentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Head request to preflight a download of a specified document
         * @param {number} documentId 
         * @param {string} [token] 
         * @param {ProductType} [productType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headDocumentHead(documentId: number, token?: string, productType?: ProductType, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.headDocumentHead(documentId, token, productType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @summary Download life-policy document
     * @param {string} documentName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public downloadLifePolicyDocumentGet(documentName: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).downloadLifePolicyDocumentGet(documentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Current DPS Pre-contractual Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getCurrentDPSPrecontractualInfoGet(options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getCurrentDPSPrecontractualInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of documents for the given DPS contract.
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDPSDocumentsGet(contractId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDPSDocumentsGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download specified document
     * @param {number} documentId 
     * @param {string} [token] 
     * @param {ProductType} [productType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentGet(documentId: number, token?: string, productType?: ProductType, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentGet(documentId, token, productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of documents for the given life contract.
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getLifeDocumentsGet(contractId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getLifeDocumentsGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of documents for the given fufi life contract.
     * @param {string} proposalNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getLifeFufiDocumentsGet(proposalNumber: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getLifeFufiDocumentsGet(proposalNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of documents for the given PP contract.
     * @param {string} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getPPDocumentsGet(contractId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getPPDocumentsGet(contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of documents for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getUserDocumentsGet(options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getUserDocumentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Head request to preflight a download of a specified document
     * @param {number} documentId 
     * @param {string} [token] 
     * @param {ProductType} [productType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public headDocumentHead(documentId: number, token?: string, productType?: ProductType, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).headDocumentHead(documentId, token, productType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailAddressApi - axios parameter creator
 * @export
 */
export const EmailAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resolve authorization email address for ADB2C by userId
         * @param {GetAuthorizationEmailAddressRequest} [getAuthorizationEmailAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationEmailAddressPost: async (getAuthorizationEmailAddressRequest?: GetAuthorizationEmailAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verificationMethods/authorizationEmailAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAuthorizationEmailAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailAddressApi - functional programming interface
 * @export
 */
export const EmailAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Resolve authorization email address for ADB2C by userId
         * @param {GetAuthorizationEmailAddressRequest} [getAuthorizationEmailAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizationEmailAddressPost(getAuthorizationEmailAddressRequest?: GetAuthorizationEmailAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuthorizationEmailAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizationEmailAddressPost(getAuthorizationEmailAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAddressApi.getAuthorizationEmailAddressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailAddressApi - factory interface
 * @export
 */
export const EmailAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Resolve authorization email address for ADB2C by userId
         * @param {GetAuthorizationEmailAddressRequest} [getAuthorizationEmailAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationEmailAddressPost(getAuthorizationEmailAddressRequest?: GetAuthorizationEmailAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAuthorizationEmailAddressResponse> {
            return localVarFp.getAuthorizationEmailAddressPost(getAuthorizationEmailAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailAddressApi - object-oriented interface
 * @export
 * @class EmailAddressApi
 * @extends {BaseAPI}
 */
export class EmailAddressApi extends BaseAPI {
    /**
     * 
     * @summary Resolve authorization email address for ADB2C by userId
     * @param {GetAuthorizationEmailAddressRequest} [getAuthorizationEmailAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailAddressApi
     */
    public getAuthorizationEmailAddressPost(getAuthorizationEmailAddressRequest?: GetAuthorizationEmailAddressRequest, options?: RawAxiosRequestConfig) {
        return EmailAddressApiFp(this.configuration).getAuthorizationEmailAddressPost(getAuthorizationEmailAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalApi - axios parameter creator
 * @export
 */
export const InternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/api-health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get count of users in ADB2C
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getADUsersCountGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/users-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangesStatisticsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/changes-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.apiHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get count of users in ADB2C
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getADUsersCountGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getADUsersCountGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getADUsersCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChangesStatisticsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChangesStatisticsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getChangesStatisticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get count of users in ADB2C
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getADUsersCountGet(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getADUsersCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangesStatisticsGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getChangesStatisticsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public apiHealthGet(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).apiHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get count of users in ADB2C
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getADUsersCountGet(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getADUsersCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getChangesStatisticsGet(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getChangesStatisticsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvestorProfileApi - axios parameter creator
 * @export
 */
export const InvestorProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get questions for investment profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestorProfileQuestionsApimGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/investor-profile/v2/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get questions for investment profile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getInvestorProfileQuestionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/investor-profile/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get questionnaire config for investment profile (funds, profiles, strategies)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestorQuestionnaireConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/investor-profile/questionnaire-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve answers for investment profile questions
         * @param {QuestionnaireEvaluateRequestAnswers} questionnaireEvaluateRequestAnswers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInvestorProfileApimPost: async (questionnaireEvaluateRequestAnswers: QuestionnaireEvaluateRequestAnswers, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionnaireEvaluateRequestAnswers' is not null or undefined
            assertParamExists('postInvestorProfileApimPost', 'questionnaireEvaluateRequestAnswers', questionnaireEvaluateRequestAnswers)
            const localVarPath = `/investor-profile/v2/resolve-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionnaireEvaluateRequestAnswers, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve answers for investment profile questions
         * @param {UserAnswersRequest} userAnswersRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postInvestorProfilePost: async (userAnswersRequest: UserAnswersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAnswersRequest' is not null or undefined
            assertParamExists('postInvestorProfilePost', 'userAnswersRequest', userAnswersRequest)
            const localVarPath = `/investor-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAnswersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvestorProfileApi - functional programming interface
 * @export
 */
export const InvestorProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvestorProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get questions for investment profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestorProfileQuestionsApimGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireQuestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestorProfileQuestionsApimGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvestorProfileApi.getInvestorProfileQuestionsApimGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get questions for investment profile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getInvestorProfileQuestionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Questions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestorProfileQuestionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvestorProfileApi.getInvestorProfileQuestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get questionnaire config for investment profile (funds, profiles, strategies)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvestorQuestionnaireConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestorQuestionnaireConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvestorProfileApi.getInvestorQuestionnaireConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolve answers for investment profile questions
         * @param {QuestionnaireEvaluateRequestAnswers} questionnaireEvaluateRequestAnswers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInvestorProfileApimPost(questionnaireEvaluateRequestAnswers: QuestionnaireEvaluateRequestAnswers, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireEvaluateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInvestorProfileApimPost(questionnaireEvaluateRequestAnswers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvestorProfileApi.postInvestorProfileApimPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolve answers for investment profile questions
         * @param {UserAnswersRequest} userAnswersRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async postInvestorProfilePost(userAnswersRequest: UserAnswersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestorProfileResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInvestorProfilePost(userAnswersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvestorProfileApi.postInvestorProfilePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvestorProfileApi - factory interface
 * @export
 */
export const InvestorProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvestorProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Get questions for investment profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestorProfileQuestionsApimGet(options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireQuestions> {
            return localVarFp.getInvestorProfileQuestionsApimGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get questions for investment profile
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getInvestorProfileQuestionsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Questions>> {
            return localVarFp.getInvestorProfileQuestionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get questionnaire config for investment profile (funds, profiles, strategies)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvestorQuestionnaireConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireConfig> {
            return localVarFp.getInvestorQuestionnaireConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve answers for investment profile questions
         * @param {QuestionnaireEvaluateRequestAnswers} questionnaireEvaluateRequestAnswers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInvestorProfileApimPost(questionnaireEvaluateRequestAnswers: QuestionnaireEvaluateRequestAnswers, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireEvaluateResult> {
            return localVarFp.postInvestorProfileApimPost(questionnaireEvaluateRequestAnswers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve answers for investment profile questions
         * @param {UserAnswersRequest} userAnswersRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postInvestorProfilePost(userAnswersRequest: UserAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvestorProfileResult> {
            return localVarFp.postInvestorProfilePost(userAnswersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvestorProfileApi - object-oriented interface
 * @export
 * @class InvestorProfileApi
 * @extends {BaseAPI}
 */
export class InvestorProfileApi extends BaseAPI {
    /**
     * 
     * @summary Get questions for investment profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestorProfileApi
     */
    public getInvestorProfileQuestionsApimGet(options?: RawAxiosRequestConfig) {
        return InvestorProfileApiFp(this.configuration).getInvestorProfileQuestionsApimGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get questions for investment profile
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof InvestorProfileApi
     */
    public getInvestorProfileQuestionsGet(options?: RawAxiosRequestConfig) {
        return InvestorProfileApiFp(this.configuration).getInvestorProfileQuestionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get questionnaire config for investment profile (funds, profiles, strategies)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestorProfileApi
     */
    public getInvestorQuestionnaireConfigGet(options?: RawAxiosRequestConfig) {
        return InvestorProfileApiFp(this.configuration).getInvestorQuestionnaireConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve answers for investment profile questions
     * @param {QuestionnaireEvaluateRequestAnswers} questionnaireEvaluateRequestAnswers 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestorProfileApi
     */
    public postInvestorProfileApimPost(questionnaireEvaluateRequestAnswers: QuestionnaireEvaluateRequestAnswers, options?: RawAxiosRequestConfig) {
        return InvestorProfileApiFp(this.configuration).postInvestorProfileApimPost(questionnaireEvaluateRequestAnswers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve answers for investment profile questions
     * @param {UserAnswersRequest} userAnswersRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof InvestorProfileApi
     */
    public postInvestorProfilePost(userAnswersRequest: UserAnswersRequest, options?: RawAxiosRequestConfig) {
        return InvestorProfileApiFp(this.configuration).postInvestorProfilePost(userAnswersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnerLoginApi - axios parameter creator
 * @export
 */
export const PartnerLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authorize payload to allow continuation of AD B2C login process
         * @param {AuthorizeRequest} [authorizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizePost: async (authorizeRequest?: AuthorizeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner-login/authorize-partner-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authorize payload to allow continuation of AD B2C login process
         * @param {AuthorizeRequest} [authorizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeV2Post: async (authorizeRequest?: AuthorizeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner-login/v2/authorize-partner-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Try to create login payload for a trusted third party
         * @param {CreateLoginPayloadRequest} [createLoginPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoginPayloadPost: async (createLoginPayloadRequest?: CreateLoginPayloadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner-login/create-login-payload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoginPayloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerLoginApi - functional programming interface
 * @export
 */
export const PartnerLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authorize payload to allow continuation of AD B2C login process
         * @param {AuthorizeRequest} [authorizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizePost(authorizeRequest?: AuthorizeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizePost(authorizeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerLoginApi.authorizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authorize payload to allow continuation of AD B2C login process
         * @param {AuthorizeRequest} [authorizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeV2Post(authorizeRequest?: AuthorizeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeV2Post(authorizeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerLoginApi.authorizeV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Try to create login payload for a trusted third party
         * @param {CreateLoginPayloadRequest} [createLoginPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLoginPayloadPost(createLoginPayloadRequest?: CreateLoginPayloadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLoginPayloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLoginPayloadPost(createLoginPayloadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerLoginApi.createLoginPayloadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerLoginApi - factory interface
 * @export
 */
export const PartnerLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerLoginApiFp(configuration)
    return {
        /**
         * 
         * @summary Authorize payload to allow continuation of AD B2C login process
         * @param {AuthorizeRequest} [authorizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizePost(authorizeRequest?: AuthorizeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizeResponse> {
            return localVarFp.authorizePost(authorizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authorize payload to allow continuation of AD B2C login process
         * @param {AuthorizeRequest} [authorizeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeV2Post(authorizeRequest?: AuthorizeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizeResponse> {
            return localVarFp.authorizeV2Post(authorizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Try to create login payload for a trusted third party
         * @param {CreateLoginPayloadRequest} [createLoginPayloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoginPayloadPost(createLoginPayloadRequest?: CreateLoginPayloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLoginPayloadResponse> {
            return localVarFp.createLoginPayloadPost(createLoginPayloadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerLoginApi - object-oriented interface
 * @export
 * @class PartnerLoginApi
 * @extends {BaseAPI}
 */
export class PartnerLoginApi extends BaseAPI {
    /**
     * 
     * @summary Authorize payload to allow continuation of AD B2C login process
     * @param {AuthorizeRequest} [authorizeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLoginApi
     */
    public authorizePost(authorizeRequest?: AuthorizeRequest, options?: RawAxiosRequestConfig) {
        return PartnerLoginApiFp(this.configuration).authorizePost(authorizeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authorize payload to allow continuation of AD B2C login process
     * @param {AuthorizeRequest} [authorizeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLoginApi
     */
    public authorizeV2Post(authorizeRequest?: AuthorizeRequest, options?: RawAxiosRequestConfig) {
        return PartnerLoginApiFp(this.configuration).authorizeV2Post(authorizeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Try to create login payload for a trusted third party
     * @param {CreateLoginPayloadRequest} [createLoginPayloadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLoginApi
     */
    public createLoginPayloadPost(createLoginPayloadRequest?: CreateLoginPayloadRequest, options?: RawAxiosRequestConfig) {
        return PartnerLoginApiFp(this.configuration).createLoginPayloadPost(createLoginPayloadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PhoneNUmberApi - axios parameter creator
 * @export
 */
export const PhoneNUmberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resolve authorization phone number for ADB2C by userId
         * @param {GetAuthorizationPhoneNumberRequest} [getAuthorizationPhoneNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationPhoneNumberPost: async (getAuthorizationPhoneNumberRequest?: GetAuthorizationPhoneNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verificationMethods/authorizationPhoneNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAuthorizationPhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post phone verification number to ADB2C
         * @param {SavePhoneNumberRequest} [savePhoneNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePhoneNumberPost: async (savePhoneNumberRequest?: SavePhoneNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verificationMethods/phoneNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhoneNUmberApi - functional programming interface
 * @export
 */
export const PhoneNUmberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhoneNUmberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Resolve authorization phone number for ADB2C by userId
         * @param {GetAuthorizationPhoneNumberRequest} [getAuthorizationPhoneNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizationPhoneNumberPost(getAuthorizationPhoneNumberRequest?: GetAuthorizationPhoneNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuthorizationPhoneNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizationPhoneNumberPost(getAuthorizationPhoneNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNUmberApi.getAuthorizationPhoneNumberPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post phone verification number to ADB2C
         * @param {SavePhoneNumberRequest} [savePhoneNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePhoneNumberPost(savePhoneNumberRequest?: SavePhoneNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePhoneNumberPost(savePhoneNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneNUmberApi.savePhoneNumberPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PhoneNUmberApi - factory interface
 * @export
 */
export const PhoneNUmberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhoneNUmberApiFp(configuration)
    return {
        /**
         * 
         * @summary Resolve authorization phone number for ADB2C by userId
         * @param {GetAuthorizationPhoneNumberRequest} [getAuthorizationPhoneNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationPhoneNumberPost(getAuthorizationPhoneNumberRequest?: GetAuthorizationPhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAuthorizationPhoneNumberResponse> {
            return localVarFp.getAuthorizationPhoneNumberPost(getAuthorizationPhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post phone verification number to ADB2C
         * @param {SavePhoneNumberRequest} [savePhoneNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePhoneNumberPost(savePhoneNumberRequest?: SavePhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.savePhoneNumberPost(savePhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhoneNUmberApi - object-oriented interface
 * @export
 * @class PhoneNUmberApi
 * @extends {BaseAPI}
 */
export class PhoneNUmberApi extends BaseAPI {
    /**
     * 
     * @summary Resolve authorization phone number for ADB2C by userId
     * @param {GetAuthorizationPhoneNumberRequest} [getAuthorizationPhoneNumberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNUmberApi
     */
    public getAuthorizationPhoneNumberPost(getAuthorizationPhoneNumberRequest?: GetAuthorizationPhoneNumberRequest, options?: RawAxiosRequestConfig) {
        return PhoneNUmberApiFp(this.configuration).getAuthorizationPhoneNumberPost(getAuthorizationPhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post phone verification number to ADB2C
     * @param {SavePhoneNumberRequest} [savePhoneNumberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneNUmberApi
     */
    public savePhoneNumberPost(savePhoneNumberRequest?: SavePhoneNumberRequest, options?: RawAxiosRequestConfig) {
        return PhoneNUmberApiFp(this.configuration).savePhoneNumberPost(savePhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PostLoginApi - axios parameter creator
 * @export
 */
export const PostLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Put confirmation of electronic contacts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmContactsPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/post-login/confirm-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get initial, post login, actions for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostLoginInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/post-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post electronic contacts for the current user.
         * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveElectronicsContactsObjectIdPost: async (saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/save-electronics-contacts-object-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveElectronicsContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post electronic contacts for the current user.
         * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveElectronicsContactsPost: async (saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/post-login/save-electronics-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveElectronicsContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostLoginApi - functional programming interface
 * @export
 */
export const PostLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Put confirmation of electronic contacts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmContactsPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmContactsPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostLoginApi.confirmContactsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get initial, post login, actions for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostLoginInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostLoginInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostLoginApi.getPostLoginInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post electronic contacts for the current user.
         * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveElectronicsContactsObjectIdPost(saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveElectronicsContactsObjectIdPost(saveElectronicsContactsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostLoginApi.saveElectronicsContactsObjectIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post electronic contacts for the current user.
         * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveElectronicsContactsPost(saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveElectronicsContactsPost(saveElectronicsContactsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostLoginApi.saveElectronicsContactsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PostLoginApi - factory interface
 * @export
 */
export const PostLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostLoginApiFp(configuration)
    return {
        /**
         * 
         * @summary Put confirmation of electronic contacts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmContactsPut(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmContactsPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get initial, post login, actions for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostLoginInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<PostLoginResponse> {
            return localVarFp.getPostLoginInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post electronic contacts for the current user.
         * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveElectronicsContactsObjectIdPost(saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveElectronicsContactsObjectIdPost(saveElectronicsContactsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post electronic contacts for the current user.
         * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveElectronicsContactsPost(saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveElectronicsContactsPost(saveElectronicsContactsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostLoginApi - object-oriented interface
 * @export
 * @class PostLoginApi
 * @extends {BaseAPI}
 */
export class PostLoginApi extends BaseAPI {
    /**
     * 
     * @summary Put confirmation of electronic contacts for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostLoginApi
     */
    public confirmContactsPut(options?: RawAxiosRequestConfig) {
        return PostLoginApiFp(this.configuration).confirmContactsPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get initial, post login, actions for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostLoginApi
     */
    public getPostLoginInfoGet(options?: RawAxiosRequestConfig) {
        return PostLoginApiFp(this.configuration).getPostLoginInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post electronic contacts for the current user.
     * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostLoginApi
     */
    public saveElectronicsContactsObjectIdPost(saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options?: RawAxiosRequestConfig) {
        return PostLoginApiFp(this.configuration).saveElectronicsContactsObjectIdPost(saveElectronicsContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post electronic contacts for the current user.
     * @param {SaveElectronicsContactsRequest} [saveElectronicsContactsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostLoginApi
     */
    public saveElectronicsContactsPost(saveElectronicsContactsRequest?: SaveElectronicsContactsRequest, options?: RawAxiosRequestConfig) {
        return PostLoginApiFp(this.configuration).saveElectronicsContactsPost(saveElectronicsContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change user\'s contact addresses
         * @param {ChangeContactAddressesRequest} [changeContactAddressesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeContactAddressesPut: async (changeContactAddressesRequest?: ChangeContactAddressesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/contact-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeContactAddressesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s contact addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactAddressesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/contact-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user profile information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get portal profile information from registrations table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileV2Get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change user\'s contact addresses
         * @param {ChangeContactAddressesRequest} [changeContactAddressesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeContactAddressesPut(changeContactAddressesRequest?: ChangeContactAddressesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeContactAddressesPut(changeContactAddressesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.changeContactAddressesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user\'s contact addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactAddressesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetContactAddressesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactAddressesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getContactAddressesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user profile information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get portal profile information from registrations table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileV2Get(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfileV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileV2Get(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getProfileV2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Change user\'s contact addresses
         * @param {ChangeContactAddressesRequest} [changeContactAddressesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeContactAddressesPut(changeContactAddressesRequest?: ChangeContactAddressesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeContactAddressesPut(changeContactAddressesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user\'s contact addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactAddressesGet(options?: RawAxiosRequestConfig): AxiosPromise<GetContactAddressesResponse> {
            return localVarFp.getContactAddressesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user profile information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileGet(options?: RawAxiosRequestConfig): AxiosPromise<GetProfileResponse> {
            return localVarFp.getProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get portal profile information from registrations table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileV2Get(options?: RawAxiosRequestConfig): AxiosPromise<GetProfileV2Response> {
            return localVarFp.getProfileV2Get(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @summary Change user\'s contact addresses
     * @param {ChangeContactAddressesRequest} [changeContactAddressesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public changeContactAddressesPut(changeContactAddressesRequest?: ChangeContactAddressesRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).changeContactAddressesPut(changeContactAddressesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user\'s contact addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getContactAddressesGet(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getContactAddressesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user profile information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getProfileGet(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get portal profile information from registrations table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getProfileV2Get(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getProfileV2Get(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegistrationApi - axios parameter creator
 * @export
 */
export const RegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Decipher user (object) id from a symmetric cipher
         * @param {ActiveDirectoryUserIdRequest} activeDirectoryUserIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeDirectoryUserIdPost: async (activeDirectoryUserIdRequest: ActiveDirectoryUserIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activeDirectoryUserIdRequest' is not null or undefined
            assertParamExists('activeDirectoryUserIdPost', 'activeDirectoryUserIdRequest', activeDirectoryUserIdRequest)
            const localVarPath = `/active-directory-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activeDirectoryUserIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate ciper, tag, nonce
         * @param {RegisterValidateLoginRequest} [registerValidateLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeRegisterPost: async (registerValidateLoginRequest?: RegisterValidateLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authorize-register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerValidateLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable user account
         * @param {EnableUserAccountRequest} enableUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUserAccountPost: async (enableUserAccountRequest: EnableUserAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enableUserAccountRequest' is not null or undefined
            assertParamExists('enableUserAccountPost', 'enableUserAccountRequest', enableUserAccountRequest)
            const localVarPath = `/enable-user-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Encrypt provided user detail info
         * @param {EncryptUserDetailInfoRequest} encryptUserDetailInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptUserDetailInfoPost: async (encryptUserDetailInfoRequest: EncryptUserDetailInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encryptUserDetailInfoRequest' is not null or undefined
            assertParamExists('encryptUserDetailInfoPost', 'encryptUserDetailInfoRequest', encryptUserDetailInfoRequest)
            const localVarPath = `/encrypt-user-detail-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encryptUserDetailInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finalize register user
         * @param {FinalizeRegisterDataRequest} finalizeRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeUserRegistrationPost: async (finalizeRegisterDataRequest: FinalizeRegisterDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'finalizeRegisterDataRequest' is not null or undefined
            assertParamExists('finalizeUserRegistrationPost', 'finalizeRegisterDataRequest', finalizeRegisterDataRequest)
            const localVarPath = `/finalize-user-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeRegisterDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate provided registration data adn create AD user
         * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAccountRegistrationPost: async (localAccountRegistrationRequest: LocalAccountRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'localAccountRegistrationRequest' is not null or undefined
            assertParamExists('localAccountRegistrationPost', 'localAccountRegistrationRequest', localAccountRegistrationRequest)
            const localVarPath = `/local-account-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(localAccountRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate provided registration data adn create AD user
         * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAccountRegistrationV2Post: async (localAccountRegistrationRequest: LocalAccountRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'localAccountRegistrationRequest' is not null or undefined
            assertParamExists('localAccountRegistrationV2Post', 'localAccountRegistrationRequest', localAccountRegistrationRequest)
            const localVarPath = `/v2/local-account-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(localAccountRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Try resolve information from registration into a PID
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPost: async (registerRequest: RegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('registerPost', 'registerRequest', registerRequest)
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Try resolve information from registration into a MPK
         * @param {RegisterRequestV2} registerRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerV2Post: async (registerRequestV2: RegisterRequestV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequestV2' is not null or undefined
            assertParamExists('registerV2Post', 'registerRequestV2', registerRequestV2)
            const localVarPath = `/v2/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ADB2CAuthFlow required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save additional register data
         * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdditionalRegisterDataPost: async (additionalRegisterDataRequest: AdditionalRegisterDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalRegisterDataRequest' is not null or undefined
            assertParamExists('saveAdditionalRegisterDataPost', 'additionalRegisterDataRequest', additionalRegisterDataRequest)
            const localVarPath = `/register-user-save-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalRegisterDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save additional register data
         * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdditionalRegisterDataV2Post: async (additionalRegisterDataRequest: AdditionalRegisterDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalRegisterDataRequest' is not null or undefined
            assertParamExists('saveAdditionalRegisterDataV2Post', 'additionalRegisterDataRequest', additionalRegisterDataRequest)
            const localVarPath = `/v2/register-user-save-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalRegisterDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate provided birth number againts AD B2C
         * @param {ValidateBirthNumberRequest} validateBirthNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBirthNumberPost: async (validateBirthNumberRequest: ValidateBirthNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateBirthNumberRequest' is not null or undefined
            assertParamExists('validateBirthNumberPost', 'validateBirthNumberRequest', validateBirthNumberRequest)
            const localVarPath = `/validate-birth-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateBirthNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate provided email againts AD B2C
         * @param {ValidateLocalAccountRequest} validateLocalAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLocalAccountPost: async (validateLocalAccountRequest: ValidateLocalAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateLocalAccountRequest' is not null or undefined
            assertParamExists('validateLocalAccountPost', 'validateLocalAccountRequest', validateLocalAccountRequest)
            const localVarPath = `/validate-local-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateLocalAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationApi - functional programming interface
 * @export
 */
export const RegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Decipher user (object) id from a symmetric cipher
         * @param {ActiveDirectoryUserIdRequest} activeDirectoryUserIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activeDirectoryUserIdPost(activeDirectoryUserIdRequest: ActiveDirectoryUserIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeDirectoryUserIdPost(activeDirectoryUserIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.activeDirectoryUserIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate ciper, tag, nonce
         * @param {RegisterValidateLoginRequest} [registerValidateLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeRegisterPost(registerValidateLoginRequest?: RegisterValidateLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeRegisterPost(registerValidateLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.authorizeRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable user account
         * @param {EnableUserAccountRequest} enableUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableUserAccountPost(enableUserAccountRequest: EnableUserAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableUserAccountPost(enableUserAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.enableUserAccountPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Encrypt provided user detail info
         * @param {EncryptUserDetailInfoRequest} encryptUserDetailInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async encryptUserDetailInfoPost(encryptUserDetailInfoRequest: EncryptUserDetailInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.encryptUserDetailInfoPost(encryptUserDetailInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.encryptUserDetailInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finalize register user
         * @param {FinalizeRegisterDataRequest} finalizeRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeUserRegistrationPost(finalizeRegisterDataRequest: FinalizeRegisterDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeUserRegistrationPost(finalizeRegisterDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.finalizeUserRegistrationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate provided registration data adn create AD user
         * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async localAccountRegistrationPost(localAccountRegistrationRequest: LocalAccountRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AesGcmEncryptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.localAccountRegistrationPost(localAccountRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.localAccountRegistrationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate provided registration data adn create AD user
         * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async localAccountRegistrationV2Post(localAccountRegistrationRequest: LocalAccountRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AesGcmEncryptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.localAccountRegistrationV2Post(localAccountRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.localAccountRegistrationV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Try resolve information from registration into a PID
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPost(registerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Try resolve information from registration into a MPK
         * @param {RegisterRequestV2} registerRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerV2Post(registerRequestV2: RegisterRequestV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerV2Post(registerRequestV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.registerV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save additional register data
         * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAdditionalRegisterDataPost(additionalRegisterDataRequest: AdditionalRegisterDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAdditionalRegisterDataPost(additionalRegisterDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.saveAdditionalRegisterDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save additional register data
         * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAdditionalRegisterDataV2Post(additionalRegisterDataRequest: AdditionalRegisterDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveDirectoryUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAdditionalRegisterDataV2Post(additionalRegisterDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.saveAdditionalRegisterDataV2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate provided birth number againts AD B2C
         * @param {ValidateBirthNumberRequest} validateBirthNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBirthNumberPost(validateBirthNumberRequest: ValidateBirthNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBirthNumberPost(validateBirthNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.validateBirthNumberPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate provided email againts AD B2C
         * @param {ValidateLocalAccountRequest} validateLocalAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateLocalAccountPost(validateLocalAccountRequest: ValidateLocalAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateLocalAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateLocalAccountPost(validateLocalAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.validateLocalAccountPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegistrationApi - factory interface
 * @export
 */
export const RegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Decipher user (object) id from a symmetric cipher
         * @param {ActiveDirectoryUserIdRequest} activeDirectoryUserIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeDirectoryUserIdPost(activeDirectoryUserIdRequest: ActiveDirectoryUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.activeDirectoryUserIdPost(activeDirectoryUserIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate ciper, tag, nonce
         * @param {RegisterValidateLoginRequest} [registerValidateLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeRegisterPost(registerValidateLoginRequest?: RegisterValidateLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.authorizeRegisterPost(registerValidateLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable user account
         * @param {EnableUserAccountRequest} enableUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUserAccountPost(enableUserAccountRequest: EnableUserAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.enableUserAccountPost(enableUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Encrypt provided user detail info
         * @param {EncryptUserDetailInfoRequest} encryptUserDetailInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptUserDetailInfoPost(encryptUserDetailInfoRequest: EncryptUserDetailInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.encryptUserDetailInfoPost(encryptUserDetailInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finalize register user
         * @param {FinalizeRegisterDataRequest} finalizeRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeUserRegistrationPost(finalizeRegisterDataRequest: FinalizeRegisterDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.finalizeUserRegistrationPost(finalizeRegisterDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate provided registration data adn create AD user
         * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAccountRegistrationPost(localAccountRegistrationRequest: LocalAccountRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AesGcmEncryptResponse> {
            return localVarFp.localAccountRegistrationPost(localAccountRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate provided registration data adn create AD user
         * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        localAccountRegistrationV2Post(localAccountRegistrationRequest: LocalAccountRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AesGcmEncryptResponse> {
            return localVarFp.localAccountRegistrationV2Post(localAccountRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Try resolve information from registration into a PID
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponse> {
            return localVarFp.registerPost(registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Try resolve information from registration into a MPK
         * @param {RegisterRequestV2} registerRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerV2Post(registerRequestV2: RegisterRequestV2, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponseV2> {
            return localVarFp.registerV2Post(registerRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save additional register data
         * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdditionalRegisterDataPost(additionalRegisterDataRequest: AdditionalRegisterDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.saveAdditionalRegisterDataPost(additionalRegisterDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save additional register data
         * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdditionalRegisterDataV2Post(additionalRegisterDataRequest: AdditionalRegisterDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveDirectoryUserIdResponse> {
            return localVarFp.saveAdditionalRegisterDataV2Post(additionalRegisterDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate provided birth number againts AD B2C
         * @param {ValidateBirthNumberRequest} validateBirthNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBirthNumberPost(validateBirthNumberRequest: ValidateBirthNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateBirthNumberPost(validateBirthNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate provided email againts AD B2C
         * @param {ValidateLocalAccountRequest} validateLocalAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLocalAccountPost(validateLocalAccountRequest: ValidateLocalAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateLocalAccountResponse> {
            return localVarFp.validateLocalAccountPost(validateLocalAccountRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
export class RegistrationApi extends BaseAPI {
    /**
     * 
     * @summary Decipher user (object) id from a symmetric cipher
     * @param {ActiveDirectoryUserIdRequest} activeDirectoryUserIdRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public activeDirectoryUserIdPost(activeDirectoryUserIdRequest: ActiveDirectoryUserIdRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).activeDirectoryUserIdPost(activeDirectoryUserIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate ciper, tag, nonce
     * @param {RegisterValidateLoginRequest} [registerValidateLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public authorizeRegisterPost(registerValidateLoginRequest?: RegisterValidateLoginRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).authorizeRegisterPost(registerValidateLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable user account
     * @param {EnableUserAccountRequest} enableUserAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public enableUserAccountPost(enableUserAccountRequest: EnableUserAccountRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).enableUserAccountPost(enableUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Encrypt provided user detail info
     * @param {EncryptUserDetailInfoRequest} encryptUserDetailInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public encryptUserDetailInfoPost(encryptUserDetailInfoRequest: EncryptUserDetailInfoRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).encryptUserDetailInfoPost(encryptUserDetailInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finalize register user
     * @param {FinalizeRegisterDataRequest} finalizeRegisterDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public finalizeUserRegistrationPost(finalizeRegisterDataRequest: FinalizeRegisterDataRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).finalizeUserRegistrationPost(finalizeRegisterDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate provided registration data adn create AD user
     * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public localAccountRegistrationPost(localAccountRegistrationRequest: LocalAccountRegistrationRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).localAccountRegistrationPost(localAccountRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate provided registration data adn create AD user
     * @param {LocalAccountRegistrationRequest} localAccountRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public localAccountRegistrationV2Post(localAccountRegistrationRequest: LocalAccountRegistrationRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).localAccountRegistrationV2Post(localAccountRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Try resolve information from registration into a PID
     * @param {RegisterRequest} registerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registerPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registerPost(registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Try resolve information from registration into a MPK
     * @param {RegisterRequestV2} registerRequestV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public registerV2Post(registerRequestV2: RegisterRequestV2, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).registerV2Post(registerRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save additional register data
     * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public saveAdditionalRegisterDataPost(additionalRegisterDataRequest: AdditionalRegisterDataRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).saveAdditionalRegisterDataPost(additionalRegisterDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save additional register data
     * @param {AdditionalRegisterDataRequest} additionalRegisterDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public saveAdditionalRegisterDataV2Post(additionalRegisterDataRequest: AdditionalRegisterDataRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).saveAdditionalRegisterDataV2Post(additionalRegisterDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate provided birth number againts AD B2C
     * @param {ValidateBirthNumberRequest} validateBirthNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public validateBirthNumberPost(validateBirthNumberRequest: ValidateBirthNumberRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).validateBirthNumberPost(validateBirthNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate provided email againts AD B2C
     * @param {ValidateLocalAccountRequest} validateLocalAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public validateLocalAccountPost(validateLocalAccountRequest: ValidateLocalAccountRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).validateLocalAccountPost(validateLocalAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



